import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, vModelCheckbox as _vModelCheckbox, Transition as _Transition, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-50f0936e")

_pushScopeId("data-v-50f0936e")
const _hoisted_1 = { class: "product-header-actions" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_3 = { class: "product-name-header single-ellipsis" }
const _hoisted_4 = { class: "product-btn-actions d-none d-lg-flex" }
const _hoisted_5 = {
  type: "button",
  class: "button-cancel"
}
const _hoisted_6 = {
  type: "button",
  class: "button-cancel"
}
const _hoisted_7 = {
  class: "push-to-edit-order",
  type: "button"
}
const _hoisted_8 = { class: "product-form-div" }
const _hoisted_9 = { class: "product-sections" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info-solid c-red fs-28" }, null, -1)
const _hoisted_11 = { class: "mandatory-warning-info-product-details" }
const _hoisted_12 = { class: "warning-info-text" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info-solid c-red fs-28" }, null, -1)
const _hoisted_14 = { class: "mandatory-warning-info-product-details" }
const _hoisted_15 = { class: "warning-info-text" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info-solid c-red fs-28" }, null, -1)
const _hoisted_17 = { class: "mandatory-warning-info-product-details" }
const _hoisted_18 = { class: "warning-info-text" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info-solid c-red fs-28" }, null, -1)
const _hoisted_20 = { class: "mandatory-warning-info-product-details" }
const _hoisted_21 = { class: "warning-info-text" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info-solid c-red fs-28" }, null, -1)
const _hoisted_23 = { class: "mandatory-warning-info-product-details" }
const _hoisted_24 = { class: "warning-info-text" }
const _hoisted_25 = { class: "product-section-data" }
const _hoisted_26 = { class: "product-details" }
const _hoisted_27 = { class: "product-field-title" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_30 = { class: "invalid-feedback" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_32 = { class: "input-text-length" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("/30 ")
const _hoisted_34 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_35 = { class: "product-field-title" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_40 = { class: "input-text-length" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("/120 ")
const _hoisted_42 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_43 = { class: "col-12 pt-3" }
const _hoisted_44 = { class: "product-field-title" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_47 = { class: "invalid-feedback" }
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_49 = { class: "input-text-length" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("/1200 ")
const _hoisted_51 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_52 = { class: "col-12 pt-3" }
const _hoisted_53 = { class: "product-field-title" }
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_55 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_56 = { class: "invalid-feedback" }
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_58 = { class: "input-text-length" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("/1200 ")
const _hoisted_60 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_62 = { class: "col-12 pt-3" }
const _hoisted_63 = { class: "product-field-title" }
const _hoisted_64 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_65 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_66 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_67 = { class: "marker-text" }
const _hoisted_68 = { class: "invalid-feedback" }
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_73 = { class: "col-12 pt-3" }
const _hoisted_74 = { class: "product-field-title" }
const _hoisted_75 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_76 = { class: "multi-select-block" }
const _hoisted_77 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_78 = { class: "invalid-feedback" }
const _hoisted_79 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_83 = { class: "col-12 pt-3" }
const _hoisted_84 = { class: "product-field-title" }
const _hoisted_85 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_86 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_87 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_88 = { class: "marker-text" }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_91 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_92 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_93 = { class: "col-12 pt-3" }
const _hoisted_94 = { class: "product-field-title" }
const _hoisted_95 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_96 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_97 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_98 = { class: "marker-text" }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_101 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_102 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_103 = { class: "col-12 pt-3" }
const _hoisted_104 = { class: "product-field-title" }
const _hoisted_105 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_106 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_107 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_108 = { class: "marker-text" }
const _hoisted_109 = { key: 1 }
const _hoisted_110 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_111 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_112 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_113 = { class: "col-12 pt-3" }
const _hoisted_114 = { class: "product-field-title" }
const _hoisted_115 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_116 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_117 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_118 = { class: "marker-text" }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_121 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_122 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_123 = { class: "col-12 pt-3" }
const _hoisted_124 = { class: "product-field-title" }
const _hoisted_125 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_126 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_127 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_128 = { class: "marker-text" }
const _hoisted_129 = { key: 1 }
const _hoisted_130 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_131 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_132 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_133 = { class: "col-12 pt-3" }
const _hoisted_134 = { class: "product-field-title" }
const _hoisted_135 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_136 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_137 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_138 = { class: "marker-text" }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_141 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_142 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_143 = { class: "col-12 pt-3" }
const _hoisted_144 = { class: "product-field-title" }
const _hoisted_145 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_146 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_147 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_148 = { class: "marker-text" }
const _hoisted_149 = { key: 1 }
const _hoisted_150 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_151 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_152 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_153 = { class: "col-12 pt-3" }
const _hoisted_154 = { class: "product-field-title" }
const _hoisted_155 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_156 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_157 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_158 = { class: "marker-text" }
const _hoisted_159 = { key: 1 }
const _hoisted_160 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_161 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_162 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_163 = { class: "col-12 pt-3" }
const _hoisted_164 = { class: "product-field-title" }
const _hoisted_165 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_166 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_167 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_168 = { class: "marker-text" }
const _hoisted_169 = { key: 1 }
const _hoisted_170 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_171 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_172 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_173 = { class: "col-12 pt-3" }
const _hoisted_174 = { class: "product-field-title" }
const _hoisted_175 = /*#__PURE__*/_createVNode("span", { class: "icon dark-circled-plus" }, null, -1)
const _hoisted_176 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_177 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_178 = { class: "marker-text" }
const _hoisted_179 = { key: 1 }
const _hoisted_180 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_181 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_182 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_183 = { class: "col-12 pt-3" }
const _hoisted_184 = { class: "product-field-title" }
const _hoisted_185 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_186 = { class: "multi-select-block" }
const _hoisted_187 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_188 = { key: 1 }
const _hoisted_189 = { class: "product-text" }
const _hoisted_190 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_191 = { class: "col-12 pt-3" }
const _hoisted_192 = { style: {"position":"relative"} }
const _hoisted_193 = { class: "mandatory-warning-info-product-details extraInfo-warning" }
const _hoisted_194 = { class: "warning-info-text" }
const _hoisted_195 = { class: "product-field-title" }
const _hoisted_196 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_197 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_198 = { class: "input-text-length" }
const _hoisted_199 = /*#__PURE__*/_createTextVNode("/255 ")
const _hoisted_200 = { key: 1 }
const _hoisted_201 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_202 = { class: "col-12 pt-3" }
const _hoisted_203 = { class: "product-field-title" }
const _hoisted_204 = { class: "row" }
const _hoisted_205 = { class: "col-2" }
const _hoisted_206 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_207 = { class: "col-2" }
const _hoisted_208 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_209 = { class: "col-2" }
const _hoisted_210 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_211 = { class: "col-3" }
const _hoisted_212 = { class: "col-3" }
const _hoisted_213 = {
  class: "btn btn-link btn-external-codes-export",
  type: "button"
}
const _hoisted_214 = { class: "row pt-3" }
const _hoisted_215 = {
  class: "col-12",
  style: {"text-align":"center"}
}
const _hoisted_216 = /*#__PURE__*/_createVNode("div", { class: "mt-20" }, null, -1)
const _hoisted_217 = { class: "row" }
const _hoisted_218 = { class: "col-12" }
const _hoisted_219 = { class: "row" }
const _hoisted_220 = { class: "col-6" }
const _hoisted_221 = { class: "form-text pl28" }
const _hoisted_222 = { class: "col-6" }
const _hoisted_223 = { class: "form-text pl28" }
const _hoisted_224 = {
  key: 1,
  class: "row"
}
const _hoisted_225 = { class: "col-12" }
const _hoisted_226 = /*#__PURE__*/_createVNode("span", { style: {"display":"inline-block","width":"10px"} }, ":", -1)
const _hoisted_227 = { key: 0 }
const _hoisted_228 = { key: 1 }
const _hoisted_229 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_230 = { class: "col-12 pt-3" }
const _hoisted_231 = { key: 0 }
const _hoisted_232 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_233 = { style: {"display":"flex","align-items":"center","column-gap":"10px"} }
const _hoisted_234 = { class: "product-details-title" }
const _hoisted_235 = {
  key: 0,
  class: "pt-3 sms-email-management"
}
const _hoisted_236 = { class: "order-notification-row pb-1" }
const _hoisted_237 = { class: "order-notification-rows" }
const _hoisted_238 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_239 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_240 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_241 = { key: 1 }
const _hoisted_242 = { class: "product-details-title" }
const _hoisted_243 = {
  key: 0,
  style: {"margin-bottom":"10px"},
  class: "not-active text-uppercase"
}
const _hoisted_244 = { class: "col-12 sms-email-auto-notification-container" }
const _hoisted_245 = { class: "row" }
const _hoisted_246 = { class: "row sms-email-auto-notification-block" }
const _hoisted_247 = { class: "d-block w-100" }
const _hoisted_248 = { class: "product-details-title" }
const _hoisted_249 = { class: "template-name" }
const _hoisted_250 = { class: "d-block w-100" }
const _hoisted_251 = { class: "product-details-title" }
const _hoisted_252 = { style: {"margin-bottom":"5px"} }
const _hoisted_253 = { class: "product-details" }
const _hoisted_254 = {
  class: "px-lg-3 py-3",
  style: {"height":"100%"}
}
const _hoisted_255 = { class: "d-flex justify-content-center justify-content-lg-start px-lg-3" }
const _hoisted_256 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_257 = { class: "product-details" }
const _hoisted_258 = { class: "col-12 pb-3" }
const _hoisted_259 = { class: "product-field-title" }
const _hoisted_260 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_261 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_262 = {
  key: 0,
  class: "col-12 location-block"
}
const _hoisted_263 = {
  class: "col-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_264 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-location fs-20 browse-icon" }, null, -1)
const _hoisted_265 = {
  key: 0,
  class: "col-12 map",
  id: "productAddress",
  style: {"margin-bottom":"20px"}
}
const _hoisted_266 = {
  ref: "map",
  id: "map"
}
const _hoisted_267 = {
  class: "multi-select-block ",
  style: {"padding-inline-end":"15px"}
}
const _hoisted_268 = { class: "product-field-title" }
const _hoisted_269 = { style: {"position":"relative"} }
const _hoisted_270 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_271 = { class: "invalid-feedback" }
const _hoisted_272 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_273 = /*#__PURE__*/_createVNode("small", {
  class: "form-text",
  style: {"margin-bottom":"20px"}
}, null, -1)
const _hoisted_274 = {
  key: 1,
  class: "col-12"
}
const _hoisted_275 = {
  key: 0,
  class: "map",
  id: "productAddress",
  style: {"margin-bottom":"20px"}
}
const _hoisted_276 = /*#__PURE__*/_createVNode("div", { class: "product-field-title pb-1" }, "Map Location:", -1)
const _hoisted_277 = {
  ref: "map",
  id: "map"
}
const _hoisted_278 = { class: "product-field-title" }
const _hoisted_279 = { class: "pb-3 d-inline-block" }
const _hoisted_280 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_281 = {
  key: 0,
  class: "product-field-value mb-0"
}
const _hoisted_282 = { class: "product-field-title" }
const _hoisted_283 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_284 = { class: "multi-select-block " }
const _hoisted_285 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_286 = { class: "invalid-feedback" }
const _hoisted_287 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_288 = /*#__PURE__*/_createVNode("small", {
  class: "form-text",
  style: {"margin-bottom":"20px"}
}, null, -1)
const _hoisted_289 = {
  key: 1,
  class: "pb-3 d-inline-block"
}
const _hoisted_290 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_291 = {
  key: 0,
  class: "product-field-value mb-0"
}
const _hoisted_292 = { class: "product-field-title" }
const _hoisted_293 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_294 = { class: "multi-select-block " }
const _hoisted_295 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_296 = { class: "invalid-feedback" }
const _hoisted_297 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_298 = /*#__PURE__*/_createVNode("small", {
  class: "form-text",
  style: {"margin-bottom":"20px"}
}, null, -1)
const _hoisted_299 = {
  key: 1,
  class: "pb-3 d-inline-block"
}
const _hoisted_300 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_301 = {
  key: 0,
  class: "product-field-value mb-0"
}
const _hoisted_302 = { class: "col-12" }
const _hoisted_303 = { class: "product-field-title" }
const _hoisted_304 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_305 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_306 = { class: "input-text-length" }
const _hoisted_307 = /*#__PURE__*/_createTextVNode("/300 ")
const _hoisted_308 = { class: "product-field-title" }
const _hoisted_309 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_310 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_311 = { class: "input-text-length" }
const _hoisted_312 = /*#__PURE__*/_createTextVNode("/300 ")
const _hoisted_313 = { class: "product-details" }
const _hoisted_314 = { class: "" }
const _hoisted_315 = { class: "product-details" }
const _hoisted_316 = { class: "" }
const _hoisted_317 = {
  key: 0,
  style: {"overflow":"hidden"},
  class: "p-3"
}
const _hoisted_318 = { class: "form-text small-text" }
const _hoisted_319 = {
  key: 1,
  style: {"overflow":"hidden","width":"100%"}
}
const _hoisted_320 = {
  class: "position-relative",
  style: {"text-align":"center"}
}
const _hoisted_321 = { class: "text-c mb-3 pt-3 row product-slots-filter-row" }
const _hoisted_322 = { class: "product-slots-add-slot" }
const _hoisted_323 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_324 = { class: "product-slots-filter-actions d-flex" }
const _hoisted_325 = {
  style: {"padding":"0"},
  class: "order-2 order-md-1"
}
const _hoisted_326 = { class: "orders-filter" }
const _hoisted_327 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_328 = { class: "show-filtered-slots order-1 order-md-2" }
const _hoisted_329 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_330 = { class: "product-details" }
const _hoisted_331 = {
  key: 0,
  class: "p-3"
}
const _hoisted_332 = { class: "watch-the-video p-0" }
const _hoisted_333 = {
  target: "_blank",
  href: "https://youtu.be/rGZXf3wb77Y"
}
const _hoisted_334 = { class: "form-text small-text" }
const _hoisted_335 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_336 = { style: {"z-index":"1"} }
const _hoisted_337 = { class: "edit-mode" }
const _hoisted_338 = { class: "row pt-3" }
const _hoisted_339 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-add-folder fs-24 browse-icon" }, null, -1)
const _hoisted_340 = { class: "upload-article" }
const _hoisted_341 = { class: "row photo-edit-section" }
const _hoisted_342 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_343 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_344 = {
  key: 1,
  class: "row"
}
const _hoisted_345 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_346 = { class: "row" }
const _hoisted_347 = { class: "col-lg-6 col-12" }
const _hoisted_348 = { class: "col-lg-6 col-12" }
const _hoisted_349 = {
  key: 0,
  class: "photo-wrapper"
}
const _hoisted_350 = {
  key: 0,
  class: "span covered"
}
const _hoisted_351 = { tabindex: "-1" }
const _hoisted_352 = { tabindex: "-1" }
const _hoisted_353 = /*#__PURE__*/_createVNode("div", { class: "photo-wrapper" }, [
  /*#__PURE__*/_createVNode("div", { class: "no-photo-wrapper" })
], -1)
const _hoisted_354 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_355 = {
  key: 0,
  class: "row photo-edit-section pt-2"
}
const _hoisted_356 = { class: "col-12" }
const _hoisted_357 = {
  class: "",
  style: {"z-index":"1"}
}
const _hoisted_358 = { class: "edit-mode" }
const _hoisted_359 = {
  key: 0,
  class: "col-12"
}
const _hoisted_360 = { class: "row" }
const _hoisted_361 = { class: "col-10" }
const _hoisted_362 = { class: "tickets-title pt-3" }
const _hoisted_363 = {
  key: 0,
  class: "col-2 d-flex",
  style: {"justify-content":"end"}
}
const _hoisted_364 = { class: "row photo-edit-section" }
const _hoisted_365 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_366 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_367 = {
  key: 1,
  class: "row"
}
const _hoisted_368 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_369 = { class: "row" }
const _hoisted_370 = { class: "col-lg-6 col-12" }
const _hoisted_371 = { class: "col-lg-6 col-12" }
const _hoisted_372 = {
  key: 1,
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_373 = { class: "mx-auto col-11 col-lg-11 images-order" }
const _hoisted_374 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_375 = { class: "col-4 col-md-3 photo-container pointer" }
const _hoisted_376 = { class: "photo-wrapper ticket-wrapper" }
const _hoisted_377 = { class: "col-4 col-md-3 photo-container pointer" }
const _hoisted_378 = { class: "photo-wrapper ticket-wrapper" }
const _hoisted_379 = {
  key: 0,
  class: "col-1"
}
const _hoisted_380 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
const _hoisted_381 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter mb-3" }, null, -1)
const _hoisted_382 = { class: "" }
const _hoisted_383 = { class: "edit-mode" }
const _hoisted_384 = { class: "row mx-auto" }
const _hoisted_385 = {
  key: 0,
  class: "col-12 text-c pb-3"
}
const _hoisted_386 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_387 = {
  class: "col-12 title-wrapper title-div",
  style: {"text-align":"center"}
}
const _hoisted_388 = { class: "product-title" }
const _hoisted_389 = {
  key: 1,
  class: "w-100"
}
const _hoisted_390 = { class: "row input-row" }
const _hoisted_391 = { class: "col-10 col-md-11 input-div" }
const _hoisted_392 = { class: "col-2 col-md-1 input-remove-div" }
const _hoisted_393 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_394 = {
  key: 2,
  style: {"overflow":"hidden","width":"100%"}
}
const _hoisted_395 = { class: "url-link-wrapper" }
const _hoisted_396 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_397 = /*#__PURE__*/_createVNode("div", { class: "product-delimiter" }, null, -1)
const _hoisted_398 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info info-photo-video fs-40 py-3" }, null, -1)
const _hoisted_399 = {
  class: "product-title",
  style: {"text-align":"center","width":"100%","color":"#A1A1A1"}
}
const _hoisted_400 = { class: "product-details" }
const _hoisted_401 = {
  key: 0,
  class: "p-3"
}
const _hoisted_402 = { class: "form-text small-text" }
const _hoisted_403 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_404 = { class: "edit-mode col-12 mb-3" }
const _hoisted_405 = { class: "row" }
const _hoisted_406 = { class: "col pt-3" }
const _hoisted_407 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-add-file fs-24 browse-icon" }, null, -1)
const _hoisted_408 = { class: "edit-mode col-12 col-lg-6" }
const _hoisted_409 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_410 = { tabindex: "-1" }
const _hoisted_411 = /*#__PURE__*/_createVNode("div", { class: "photo-wrapper" }, [
  /*#__PURE__*/_createVNode("div", { class: "no-photo-wrapper" })
], -1)
const _hoisted_412 = {
  key: 0,
  class: "row mx-auto col-12 pt-3",
  style: {"margin":"0"}
}
const _hoisted_413 = { class: "document-wrapper" }
const _hoisted_414 = {
  class: "file-link",
  style: {"margin-bottom":"15px !important"}
}
const _hoisted_415 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-lens fs-24" }, null, -1)
const _hoisted_416 = {
  key: 1,
  style: {"height":"100%","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_417 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info info-document fs-30" }, null, -1)
const _hoisted_418 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_419 = { style: {"font-size":"16px","color":"#A1A1A1"} }
const _hoisted_420 = { class: "product-details" }
const _hoisted_421 = { class: "row" }
const _hoisted_422 = {
  class: "col-11",
  style: {"margin-inline-start":"15px"}
}
const _hoisted_423 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_424 = { class: "d-none d-lg-flex pricing-desktop-section" }
const _hoisted_425 = { class: "w-100" }
const _hoisted_426 = { key: 0 }
const _hoisted_427 = { class: "pricing-title" }
const _hoisted_428 = { class: "pricing-date" }
const _hoisted_429 = { class: "pricing-currency" }
const _hoisted_430 = { class: "pricing-type" }
const _hoisted_431 = {
  key: 0,
  class: "pricing-row-data-actions"
}
const _hoisted_432 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-copy fs-16" }, null, -1)
const _hoisted_433 = { class: "d-flex d-lg-none pricing-mobile-section" }
const _hoisted_434 = { class: "pricing-row" }
const _hoisted_435 = { class: "pricing-row-data" }
const _hoisted_436 = { class: "pricing-row-title" }
const _hoisted_437 = { class: "pricing-row-data" }
const _hoisted_438 = { class: "pricing-row-title" }
const _hoisted_439 = /*#__PURE__*/_createVNode("span", null, " - ", -1)
const _hoisted_440 = { class: "pricing-row-data" }
const _hoisted_441 = { class: "pricing-row-title" }
const _hoisted_442 = { class: "pricing-row-data" }
const _hoisted_443 = { class: "pricing-row-title" }
const _hoisted_444 = { class: "pricing-row-data-actions" }
const _hoisted_445 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-copy fs-16" }, null, -1)
const _hoisted_446 = {
  key: 0,
  class: "product-details"
}
const _hoisted_447 = {
  key: 0,
  class: "p-lg-3 pt-3"
}
const _hoisted_448 = { class: "product-details" }
const _hoisted_449 = { class: "row pt-3 px-md-3" }
const _hoisted_450 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_451 = { class: "product-details-title" }
const _hoisted_452 = {
  key: 0,
  class: "data-to-row"
}
const _hoisted_453 = { class: "product-details-title" }
const _hoisted_454 = { class: "product-details-title" }
const _hoisted_455 = { class: "product-details-title" }
const _hoisted_456 = {
  key: 0,
  class: "row"
}
const _hoisted_457 = { class: "col-12 col-md-6" }
const _hoisted_458 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_459 = {
  key: 0,
  class: "d-flex pt-md-0 pt-2 col-12 col-md-6"
}
const _hoisted_460 = { class: "orderBlockMinutes-selectType" }
const _hoisted_461 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_462 = { key: 1 }
const _hoisted_463 = {
  key: 2,
  class: "not-active text-uppercase"
}
const _hoisted_464 = {
  key: 3,
  class: "not-active text-uppercase"
}
const _hoisted_465 = { key: 0 }
const _hoisted_466 = { class: "order-limitation-row" }
const _hoisted_467 = { class: "product-details-title" }
const _hoisted_468 = { class: "product-details-title" }
const _hoisted_469 = { key: 1 }
const _hoisted_470 = { class: "product-details-title" }
const _hoisted_471 = { key: 0 }
const _hoisted_472 = { class: "product-details-title" }
const _hoisted_473 = { class: "product-details-title" }
const _hoisted_474 = { class: "col-12 order-2 col-12 pt-3" }
const _hoisted_475 = { class: "product-details-title" }
const _hoisted_476 = { class: "col-12 order-2 col-12 pt-3" }
const _hoisted_477 = { class: "product-details-title" }
const _hoisted_478 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_479 = { class: "invalid-feedback" }
const _hoisted_480 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_481 = { class: "input-text-length" }
const _hoisted_482 = /*#__PURE__*/_createTextVNode("/255 ")
const _hoisted_483 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_484 = { class: "col-12 order-2 col-12 pt-3" }
const _hoisted_485 = { class: "product-details-title" }
const _hoisted_486 = {
  key: 0,
  class: "product-property-form-control"
}
const _hoisted_487 = { class: "input-text-length" }
const _hoisted_488 = /*#__PURE__*/_createTextVNode("/255 ")
const _hoisted_489 = {
  key: 1,
  class: "product-field-value"
}
const _hoisted_490 = { class: "col-12 order-3" }
const _hoisted_491 = { style: {"position":"relative"} }
const _hoisted_492 = { class: "mandatory-warning-info-product-details product-policy-warning" }
const _hoisted_493 = { class: "warning-info-text" }
const _hoisted_494 = { key: 0 }
const _hoisted_495 = { class: "input-text-length" }
const _hoisted_496 = /*#__PURE__*/_createTextVNode(" /255 ")
const _hoisted_497 = { key: 1 }
const _hoisted_498 = {
  key: 0,
  class: "order-4 col-12",
  style: {"height":"1px","border-top":"1px solid #D6D6D6","margin-top":"15px"}
}
const _hoisted_499 = { class: "col-12 order-5" }
const _hoisted_500 = {
  key: 0,
  class: "justify-content-evenly row"
}
const _hoisted_501 = { class: "form-check product-pricePerPerson col-12 col-md-4" }
const _hoisted_502 = { class: "form-text pl28" }
const _hoisted_503 = { class: "form-check product-pricePerPerson col-12 col-md-4" }
const _hoisted_504 = { class: "form-text pl28" }
const _hoisted_505 = { key: 1 }
const _hoisted_506 = { class: "pt-3" }
const _hoisted_507 = { class: "checkboxtext price-per-person-text" }
const _hoisted_508 = {
  class: "form-text price-per-person-example",
  style: {"opacity":"0.4"}
}
const _hoisted_509 = {
  key: 1,
  class: "delete-button-wrapper mx-auto order-5"
}
const _hoisted_510 = { class: "product-details" }
const _hoisted_511 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_512 = { class: "edit-mode about-me-section col-12 p-0 p-lg-3" }
const _hoisted_513 = {
  key: 0,
  class: "respons-person-image-block mt-3"
}
const _hoisted_514 = { class: "d-flex justify-content-evenly" }
const _hoisted_515 = {
  key: 1,
  class: "py-3"
}
const _hoisted_516 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-camera fs-26 browse-icon" }, null, -1)
const _hoisted_517 = { class: "edit-mode-row respons-person-name-block" }
const _hoisted_518 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto 16px"}
}
const _hoisted_519 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_520 = {
  key: 1,
  class: "row"
}
const _hoisted_521 = {
  class: "col-12",
  style: {"margin":"0 auto"}
}
const _hoisted_522 = { class: "row" }
const _hoisted_523 = { class: "col-6 text-center" }
const _hoisted_524 = { class: "col-6 text-center" }
const _hoisted_525 = { class: "product-property-form-control" }
const _hoisted_526 = { class: "title-wrapper" }
const _hoisted_527 = { class: "product-title align-top" }
const _hoisted_528 = { class: "input-text-length" }
const _hoisted_529 = { key: 1 }
const _hoisted_530 = /*#__PURE__*/_createTextVNode(" /30 ")
const _hoisted_531 = { class: "edit-mode-row product-property-form-control respons-person-description-block" }
const _hoisted_532 = { class: "title-wrapper d-flex justify-content-between" }
const _hoisted_533 = { class: "product-title" }
const _hoisted_534 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_535 = { class: "input-text-length" }
const _hoisted_536 = { key: 1 }
const _hoisted_537 = /*#__PURE__*/_createTextVNode(" /1200 ")
const _hoisted_538 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_539 = { class: "responsiblePersonPhotoUrl-block" }
const _hoisted_540 = { class: "px-lg-3 pt-3" }
const _hoisted_541 = { class: "product-field-title" }
const _hoisted_542 = { class: "product-field-value" }
const _hoisted_543 = { class: "px-lg-3 pt-3" }
const _hoisted_544 = { class: "product-field-title" }
const _hoisted_545 = { class: "product-field-value" }
const _hoisted_546 = { class: "product-details" }
const _hoisted_547 = { class: "pt-3" }
const _hoisted_548 = { class: "mobile-product-footer d-flex d-lg-none" }
const _hoisted_549 = {
  type: "button",
  class: "button-cancel"
}
const _hoisted_550 = {
  type: "button",
  class: "button-cancel"
}
const _hoisted_551 = {
  class: "push-to-edit-order",
  type: "button"
}
const _hoisted_552 = { id: "external-codes-search-modal" }
const _hoisted_553 = /*#__PURE__*/_createVNode("i", { class: "icon-f cancel-icon fs-24" }, null, -1)
const _hoisted_554 = { class: "row" }
const _hoisted_555 = { class: "col-8" }
const _hoisted_556 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-search fs-24",
  style: {"color":"#D6D6DC"}
}, null, -1)
const _hoisted_557 = {
  class: "col-4",
  style: {"text-align":"right"}
}
const _hoisted_558 = { class: "mt-20" }
const _hoisted_559 = {
  class: "table table-bordered",
  style: {"background":"#E4F1FB","max-height":"500px"}
}
const _hoisted_560 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { style: {"padding":"10px"} }, [
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      style: {"color":"#7F8FA4","font-weight":"400"}
    }, "Code"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      style: {"color":"#7F8FA4","font-weight":"400"}
    }, "Status")
  ])
], -1)
const _hoisted_561 = { class: "line" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_ProductFAQs = _resolveComponent("ProductFAQs")
  const _component_ProductMoreInfo = _resolveComponent("ProductMoreInfo")
  const _component_ProductSlotsTable = _resolveComponent("ProductSlotsTable")
  const _component_CalendarSlotModal = _resolveComponent("CalendarSlotModal")
  const _component_cropper = _resolveComponent("cropper")
  const _component_draggable = _resolveComponent("draggable")
  const _component_NotificationsRestrictions = _resolveComponent("NotificationsRestrictions")
  const _component_ProductSellingSettings = _resolveComponent("ProductSellingSettings")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.product.name), 1),
      _createVNode("div", _hoisted_4, [
        (_ctx.editMode)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'product', params: { id: _ctx.productId, tab: _ctx.tab } }
            }, {
              default: _withId(() => [
                _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('button.cancel')), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'catalog' }
            }, {
              default: _withId(() => [
                _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('button.catalog')), 1)
              ]),
              _: 1
            })),
        (_ctx.editMode)
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              class: "button-submit",
              type: "submit",
              ref: "submitButtonRef",
              form: "product-save-form"
            }, _toDisplayString(_ctx.$t('button.save')), 513))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: { name: 'edit-product', params: { id: _ctx.id, tab: _ctx.tab } }
            }, {
              default: _withId(() => [
                _createVNode("button", _hoisted_7, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('button.edit')), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("form", {
        onSubmit: _cache[141] || (_cache[141] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
        novalidate: "",
        id: "product-save-form",
        class: { 'mobile-form-has-selected-section': _ctx.tab != 0 }
      }, [
        _createVNode("div", {
          class: ["product-view-block", { 'mobile-has-selected-section': _ctx.tab != 0, 'product-edit-mode': _ctx.editMode }]
        }, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.Details }],
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTab(1)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.productDetails')), 1),
                (_ctx.emptyMandatoryFields.mainInfo)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "to-update-mandatory",
                      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showProductDetailsWarning = false)),
                      onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showProductDetailsWarning = true))
                    }, [
                      _hoisted_10
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('product.mandatoryWarning.productDetails')), 1)
              ], 512), [
                [_vShow, _ctx.showProductDetailsWarning]
              ])
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.FAQ }],
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setTab(2)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t('product.faq')), 1)
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.Address }],
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setTab(3)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.productAddress')), 1),
                (_ctx.emptyMandatoryFields.productAddress)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "to-update-mandatory",
                      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showProductAddressWarning = false)),
                      onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showProductAddressWarning = true))
                    }, [
                      _hoisted_13
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('product.mandatoryWarning.productDetails')), 1)
              ], 512), [
                [_vShow, _ctx.showProductAddressWarning]
              ])
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.MoreInfo }],
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setTab(4)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t('product.moreInfo')), 1)
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.TimeAndDuration }],
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setTab(5)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.productTime&Duration')), 1),
                (!_ctx.emptyMandatoryFields.productSlots)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "to-update-mandatory",
                      onMouseleave: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showDurationWarning = false)),
                      onMouseenter: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showDurationWarning = true))
                    }, [
                      _hoisted_16
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('product.mandatoryWarning.slotLess30Days')), 1)
              ], 512), [
                [_vShow, _ctx.showDurationWarning]
              ])
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.PhotosAndVideo }],
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setTab(6)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.photos&Video')), 1),
                (_ctx.emptyMandatoryFields.productImages)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "to-update-mandatory",
                      onMouseleave: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPhotosWarning = false)),
                      onMouseenter: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showPhotosWarning = true))
                    }, [
                      _hoisted_19
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('product.mandatoryWarning.productDetails')), 1)
              ], 512), [
                [_vShow, _ctx.showPhotosWarning]
              ])
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.Documents }],
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setTab(7)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t('product.documents')), 1)
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.Pricing }],
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setTab(8)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.pricing')), 1),
                (!_ctx.emptyMandatoryFields.priceList)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "to-update-mandatory",
                      onMouseleave: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showPriceListWarning = false)),
                      onMouseenter: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showPriceListWarning = true))
                    }, [
                      _hoisted_22
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('product.mandatoryWarning.productDetails')), 1)
              ], 512), [
                [_vShow, _ctx.showPriceListWarning]
              ])
            ], 2),
            (_ctx.product.id)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.Notifications }],
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.setTab(9)))
                }, [
                  _createVNode("i", {
                    class: "icon-f icon-calendar-arrow-back px-3 arrows",
                    onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
                  }),
                  _createVNode("span", null, _toDisplayString(_ctx.$t('providers.notifications.title')), 1)
                ], 2))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.General }],
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.setTab(10)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t('product.general')), 1)
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.ActivityOwner }],
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.setTab(11)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t('product.about-responsible-person')), 1)
            ], 2),
            _createVNode("div", {
              class: ["product-section", { 'product-selected-section': _ctx.tab == _ctx.productDetailSections.SellingSettings }],
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.setTab(12)))
            }, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.skipSection()), ["stop"]))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.name')), 1)
            ], 2)
          ]),
          _createVNode("div", _hoisted_25, [
            _withDirectives(_createVNode("div", _hoisted_26, [
              _createVNode("div", {
                class: ["row py-3 px-md-3", { 'px-3': _ctx.editMode }]
              }, [
                _createVNode("div", {
                  class: ["col-12", { 'col-md-6': _ctx.editMode }]
                }, [
                  _createVNode("span", _hoisted_27, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.productName')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.routeToEdit('name')))
                        }, [
                          _hoisted_28
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_29, [
                        _withDirectives(_createVNode("input", {
                          "data-tab": _ctx.productDetailSections.Details,
                          type: "text",
                          maxlength: "30",
                          required: "",
                          class: "bookit-input product-input form-control h38",
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.product.name = $event))
                        }, null, 8, ["data-tab"]), [
                          [
                            _vModelText,
                            _ctx.product.name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("span", _hoisted_30, [
                          _hoisted_31,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _createVNode("span", _hoisted_32, [
                          _createVNode("span", {
                            class: { 'length-limit': _ctx.product.name.length > 29 }
                          }, _toDisplayString(_ctx.product.name.length), 3),
                          _hoisted_33
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_34, _toDisplayString(_ctx.product.name), 1))
                ], 2),
                _createVNode("div", {
                  class: ["col-12 pt-3 pt-md-0", _ctx.editMode ? 'col-md-6' : 'pt-lg-3']
                }, [
                  _createVNode("span", _hoisted_35, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.shortDescription')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.routeToEdit('shortdescription')))
                        }, [
                          _hoisted_36
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_37, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "shortDescription",
                          class: "bookit-textarea product-textarea resize-off short-description form-control",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.product.shortDescription = $event)),
                          style: {"max-height":"57px"},
                          maxlength: "120",
                          "data-tab": _ctx.productDetailSections.Details,
                          required: ""
                        }, null, 8, ["data-tab"]), [
                          [
                            _vModelText,
                            _ctx.product.shortDescription,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("span", _hoisted_38, [
                          _hoisted_39,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _createVNode("span", _hoisted_40, [
                          _createVNode("span", {
                            class: { 'length-limit': _ctx.product.shortDescription.length > 119 }
                          }, _toDisplayString(_ctx.product.shortDescription.length), 3),
                          _hoisted_41
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_42, _toDisplayString(_ctx.product.shortDescription), 1))
                ], 2),
                _createVNode("div", _hoisted_43, [
                  _createVNode("span", _hoisted_44, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.longDescription')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.routeToEdit('fulldescription')))
                        }, [
                          _hoisted_45
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_46, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "fullDescription",
                          class: "bookit-textarea product-textarea resize-off short-description form-control",
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.product.fullDescription = $event)),
                          style: {"max-height":"80px","height":"80px"},
                          maxlength: "1200",
                          "data-tab": _ctx.productDetailSections.Details,
                          required: ""
                        }, null, 8, ["data-tab"]), [
                          [
                            _vModelText,
                            _ctx.product.fullDescription,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("span", _hoisted_47, [
                          _hoisted_48,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _createVNode("span", _hoisted_49, [
                          _createVNode("span", {
                            class: { 'length-limit': _ctx.product.fullDescription.length > 1119 }
                          }, _toDisplayString(_ctx.product.fullDescription.length), 3),
                          _hoisted_50
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_51, _toDisplayString(_ctx.product.fullDescription), 1))
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode("span", _hoisted_53, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.long-description-index')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.routeToEdit('fulldescriptionIndex')))
                        }, [
                          _hoisted_54
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_55, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "fullDescription",
                          class: "bookit-textarea product-textarea resize-off short-description form-control",
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.product.fullDescriptionIndex = $event)),
                          style: {"max-height":"80px","height":"80px"},
                          maxlength: "1200",
                          "data-tab": _ctx.productDetailSections.Details,
                          required: ""
                        }, null, 8, ["data-tab"]), [
                          [
                            _vModelText,
                            _ctx.product.fullDescriptionIndex,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("span", _hoisted_56, [
                          _hoisted_57,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _createVNode("span", _hoisted_58, [
                          _createVNode("span", {
                            class: { 'length-limit': _ctx.product.fullDescriptionIndex.length > 1119 }
                          }, _toDisplayString(_ctx.product.fullDescriptionIndex.length), 3),
                          _hoisted_59
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_60, _toDisplayString(_ctx.product.fullDescriptionIndex), 1))
                ]),
                _hoisted_61,
                _createVNode("div", _hoisted_62, [
                  _createVNode("span", _hoisted_63, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.region')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-regions',
                                                params: { tagId: _ctx.foodDrinkId, productId: _ctx.productId }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_64
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_65, [
                        _createVNode("div", _hoisted_66, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productRegions, (region) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "orange-marker-wrapper marker-wrapper",
                              key: region.id
                            }, [
                              _createVNode("span", _hoisted_67, _toDisplayString(region.regionName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteRegion(region))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]),
                        _withDirectives(_createVNode("input", {
                          required: "",
                          class: "d-none",
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.product.productRegions = $event)),
                          "data-tab": _ctx.productDetailSections.Details
                        }, null, 8, ["data-tab"]), [
                          [_vModelText, _ctx.product.productRegions]
                        ]),
                        _createVNode("span", _hoisted_68, [
                          _hoisted_69,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_70, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productRegions, (region, index) => {
                          return (_openBlock(), _createBlock("span", {
                            key: region.id,
                            class: "product-text"
                          }, [
                            _createTextVNode(_toDisplayString(region.regionName), 1),
                            (index != _ctx.product.productRegions.length - 1)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _hoisted_71
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                ]),
                _hoisted_72,
                _createVNode("div", _hoisted_73, [
                  _createVNode("span", _hoisted_74, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.typeOfProduct')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_75, [
                        _createVNode("div", _hoisted_76, [
                          _createVNode(_component_Multiselect, _mergeProps({
                            class: { 'form-controll-multiselect': !_ctx.product.productTypeId },
                            required: "",
                            "data-tab": _ctx.productDetailSections.Details,
                            canDeselect: false,
                            modelValue: _ctx.product.productTypeId,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.product.productTypeId = $event))
                          }, _ctx.productTypeSelect, { class: "custom-multiselect-input" }), {
                            caret: _withId(() => [
                              _hoisted_77
                            ]),
                            _: 1
                          }, 16, ["class", "data-tab", "modelValue"]),
                          _withDirectives(_createVNode("input", {
                            required: "",
                            class: "d-none",
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.product.productTypeId = $event)),
                            "data-tab": _ctx.productDetailSections.Details
                          }, null, 8, ["data-tab"]), [
                            [_vModelText, _ctx.product.productTypeId]
                          ]),
                          (_ctx.product.productTypeId)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.product.productTypeId = null)),
                                class: "marker-remove"
                              }))
                            : _createCommentVNode("", true),
                          _createVNode("span", _hoisted_78, [
                            _hoisted_79,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_80, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productTypes, (tag) => {
                          return (_openBlock(), _createBlock("span", {
                            class: "product-text",
                            key: tag.id
                          }, [
                            (tag.id === _ctx.product.productTypeId)
                              ? (_openBlock(), _createBlock("span", _hoisted_81, _toDisplayString(tag.name), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                ]),
                _hoisted_82,
                _createVNode("div", _hoisted_83, [
                  _createVNode("span", _hoisted_84, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.subTypes')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: { tagId: _ctx.subTypeId, productId: _ctx.productId, type: 'sub-types' }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_85
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_86, [
                        _createVNode("div", _hoisted_87, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "orange-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_88, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_89, [
                        _createVNode("div", _hoisted_90, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.subTypeTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_91
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_92,
                _createVNode("div", _hoisted_93, [
                  _createVNode("span", _hoisted_94, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.targetAudiences')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: {
                                                    tagId: _ctx.targetAudiencesId,
                                                    productId: _ctx.productId,
                                                    type: 'target-audiences'
                                                }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_95
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_96, [
                        _createVNode("div", _hoisted_97, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetAudiencesTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "blue-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_98, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_99, [
                        _createVNode("div", _hoisted_100, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetAudiencesTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.targetAudiencesTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_101
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_102,
                _createVNode("div", _hoisted_103, [
                  _createVNode("span", _hoisted_104, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.entrance')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: { tagId: _ctx.entranceId, productId: _ctx.productId, type: 'entrance' }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_105
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_106, [
                        _createVNode("div", _hoisted_107, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entranceTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "blue-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_108, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_109, [
                        _createVNode("div", _hoisted_110, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entranceTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.entranceTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_111
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_112,
                _createVNode("div", _hoisted_113, [
                  _createVNode("span", _hoisted_114, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.foodAndDrinks')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: { tagId: _ctx.foodDrinkId, productId: _ctx.productId, type: 'food-drinks' }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_115
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_116, [
                        _createVNode("div", _hoisted_117, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodDrinkTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "blue-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_118, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_119, [
                        _createVNode("div", _hoisted_120, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodDrinkTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.foodDrinkTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_121
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_122,
                _createVNode("div", _hoisted_123, [
                  _createVNode("span", _hoisted_124, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.religion')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: { tagId: _ctx.religionId, productId: _ctx.productId, type: 'religion' }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_125
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_126, [
                        _createVNode("div", _hoisted_127, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.religionTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "blue-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_128, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_129, [
                        _createVNode("div", _hoisted_130, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.religionTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.religionTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_131
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_132,
                _createVNode("div", _hoisted_133, [
                  _createVNode("span", _hoisted_134, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.difficultyLevel')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: {
                                                    tagId: _ctx.difficultyLevelId,
                                                    productId: _ctx.productId,
                                                    type: 'Difficulty Level'
                                                }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_135
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_136, [
                        _createVNode("div", _hoisted_137, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.difficultyLevelTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "orange-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_138, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_139, [
                        _createVNode("div", _hoisted_140, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.difficultyLevelTags(), (dif, i) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: i
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(dif.subTagName), 1),
                                (i != _ctx.difficultyLevelTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_141
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_142,
                _createVNode("div", _hoisted_143, [
                  _createVNode("span", _hoisted_144, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.languages')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: { tagId: _ctx.languagesId, productId: _ctx.productId, type: 'languages' }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_145
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_146, [
                        _createVNode("div", _hoisted_147, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languagesTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "blue-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_148, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_149, [
                        _createVNode("div", _hoisted_150, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languagesTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.languagesTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_151
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_152,
                _createVNode("div", _hoisted_153, [
                  _createVNode("span", _hoisted_154, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.transportAndParking')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: {
                                                    tagId: _ctx.transportAndParkingId,
                                                    productId: _ctx.productId,
                                                    type: 'transport-parking'
                                                }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_155
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_156, [
                        _createVNode("div", _hoisted_157, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transportAndParkingTags(), (subtag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "blue-marker-wrapper marker-wrapper",
                              key: subtag.id
                            }, [
                              _createVNode("span", _hoisted_158, _toDisplayString(subtag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteTag(subtag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_159, [
                        _createVNode("div", _hoisted_160, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transportAndParkingTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(subtag.subTagName), 1),
                                (index != _ctx.transportAndParkingTags().length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_161
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_162,
                _createVNode("div", _hoisted_163, [
                  _createVNode("span", _hoisted_164, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.included')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: {
                                                    tagId: _ctx.includedNotIncludedId,
                                                    productId: _ctx.productId,
                                                    type: 'included'
                                                }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_165
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_166, [
                        _createVNode("div", _hoisted_167, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productIncludedTags, (includedTag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "green-marker-wrapper marker-wrapper",
                              key: includedTag.id
                            }, [
                              _createVNode("span", _hoisted_168, _toDisplayString(includedTag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteIncludedTag(includedTag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_169, [
                        _createVNode("div", _hoisted_170, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productIncludedTags, (productIncludedTag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: productIncludedTag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(productIncludedTag.subTagName), 1),
                                (index != _ctx.product.productIncludedTags.length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_171
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_172,
                _createVNode("div", _hoisted_173, [
                  _createVNode("span", _hoisted_174, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.excluded')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                                                name: 'modal-tags',
                                                params: {
                                                    tagId: _ctx.includedNotIncludedId,
                                                    productId: _ctx.productId,
                                                    type: 'excluded'
                                                }
                                            }
                        }, {
                          default: _withId(() => [
                            _hoisted_175
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_176, [
                        _createVNode("div", _hoisted_177, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productExcludedTags, (excludedTag) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "red-marker-wrapper marker-wrapper",
                              key: excludedTag.id
                            }, [
                              _createVNode("span", _hoisted_178, _toDisplayString(excludedTag.subTagName), 1),
                              _createVNode("span", {
                                class: "marker-remove",
                                onClick: ($event: any) => (_ctx.deleteExcludedTag(excludedTag))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_179, [
                        _createVNode("div", _hoisted_180, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productExcludedTags, (productExcludedTag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: productExcludedTag.id
                            }, [
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(productExcludedTag.subTagName), 1),
                                (index != _ctx.product.productExcludedTags.length - 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _hoisted_181
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]),
                _hoisted_182,
                _createVNode("div", _hoisted_183, [
                  _createVNode("span", _hoisted_184, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.averageActivityDuration')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_185, [
                        _createVNode("div", _hoisted_186, [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: _ctx.product.averageDurationTime,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.product.averageDurationTime = $event))
                          }, _ctx.productAverageDuration, { class: "custom-multiselect-input" }), {
                            caret: _withId(() => [
                              _hoisted_187
                            ]),
                            _: 1
                          }, 16, ["modelValue"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_188, [
                        _createVNode("span", _hoisted_189, _toDisplayString(_ctx.getAverageTime()), 1)
                      ]))
                ]),
                _hoisted_190,
                _createVNode("div", _hoisted_191, [
                  _createVNode("div", _hoisted_192, [
                    _withDirectives(_createVNode("div", _hoisted_193, [
                      _createVNode("div", _hoisted_194, _toDisplayString(_ctx.$t('help.aboutProductExtraField')), 1)
                    ], 512), [
                      [_vShow, _ctx.showExtraInfoAbout]
                    ])
                  ]),
                  _createVNode("span", _hoisted_195, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('product.extraInfo')) + ": ", 1),
                      _createVNode("i", {
                        class: "icon-f icon-info fs-20",
                        onMouseleave: _cache[48] || (_cache[48] = ($event: any) => (_ctx.showExtraInfoAbout = false)),
                        onMouseenter: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showExtraInfoAbout = true))
                      }, null, 32)
                    ]),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.routeToEdit('extraInfo')))
                        }, [
                          _hoisted_196
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_197, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "extraInfo",
                          class: "bookit-textarea product-textarea resize-off long-description form-control",
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.product.extraInfo = $event)),
                          maxlength: "255",
                          onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.checkDescription('extraInfo')))
                        }, null, 544), [
                          [_vModelText, _ctx.product.extraInfo]
                        ]),
                        _createVNode("span", _hoisted_198, [
                          _createVNode("span", {
                            class: { 'length-limit': _ctx.product.extraInfo.length > 254 }
                          }, _toDisplayString(_ctx.product.extraInfo.length), 3),
                          _hoisted_199
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_200, _toDisplayString(_ctx.product.extraInfo), 1))
                ]),
                _hoisted_201,
                _createVNode("div", _hoisted_202, [
                  _createVNode("span", _hoisted_203, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.externalCodesTitle')) + ":", 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_204, [
                      _createVNode("div", _hoisted_205, [
                        _createVNode("span", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('product.externalCodesQuantityTitle')), 1)
                        ]),
                        _hoisted_206,
                        _createVNode("span", null, _toDisplayString(_ctx.product.externalCodes_TotalQuantity), 1)
                      ]),
                      _createVNode("div", _hoisted_207, [
                        _createVNode("span", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('product.externalCodesUsedTitle')), 1)
                        ]),
                        _hoisted_208,
                        _createVNode("span", null, _toDisplayString(_ctx.product.externalCodes_UsedQuantity), 1)
                      ]),
                      _createVNode("div", _hoisted_209, [
                        _createVNode("span", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('product.externalCodesNotUsedTitle')), 1)
                        ]),
                        _hoisted_210,
                        _createVNode("span", null, _toDisplayString(_ctx.product.externalCodes_NotUsedQuantity), 1)
                      ]),
                      _createVNode("div", _hoisted_211, [
                        _createVNode("input", {
                          type: "file",
                          name: "external-codes-file-upload-input",
                          id: "external-codes-file-upload-input",
                          style: {"display":"none"},
                          onChange: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.externalCodesUploadXLS && _ctx.externalCodesUploadXLS(...args)))
                        }, null, 32),
                        _createVNode("button", {
                          class: "btn btn-link btn-external-codes-import",
                          type: "button",
                          onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.externalCodesFileInputClick && _ctx.externalCodesFileInputClick(...args)))
                        }, _toDisplayString(_ctx.$t('product.externalCodesImportXlsButtonText')), 1)
                      ]),
                      _createVNode("div", _hoisted_212, [
                        _createVNode("a", {
                          href: `/api/external-codes/export?productId=${_ctx.product.id}`,
                          target: "_blank",
                          style: {"font-weight":"700"}
                        }, [
                          _createVNode("button", _hoisted_213, _toDisplayString(_ctx.$t('product.externalCodesExportXlsButtonText')), 1)
                        ], 8, ["href"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_214, [
                      _createVNode("div", _hoisted_215, [
                        _createVNode("button", {
                          class: "btn btn-blue",
                          type: "button",
                          onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.externalCodeSearchModalOpen && _ctx.externalCodeSearchModalOpen(...args)))
                        }, _toDisplayString(_ctx.$t('product.externalCodesShowCodesButtonText')), 1)
                      ])
                    ]),
                    _hoisted_216,
                    _createVNode("div", null, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("div", _hoisted_217, [
                              _createVNode("div", _hoisted_218, [
                                _createVNode("span", null, _toDisplayString(_ctx.$t('product.externalCodesModeTitle')) + ":", 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_219, [
                              _createVNode("div", _hoisted_220, [
                                _createVNode(_component_RadioInput, {
                                  name: "externalCodesMode",
                                  value: 1,
                                  modelValue: _ctx.product.externalCodesMode,
                                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.product.externalCodesMode = $event)),
                                  class: "radio-select"
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('product.externalCodesMode_OnePerProduct')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode("small", _hoisted_221, _toDisplayString(_ctx.$t('product.externalCodesMode_OnePerProduct_Description')), 1)
                              ]),
                              _createVNode("div", _hoisted_222, [
                                _createVNode(_component_RadioInput, {
                                  name: "externalCodesMode",
                                  value: 2,
                                  modelValue: _ctx.product.externalCodesMode,
                                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.product.externalCodesMode = $event)),
                                  class: "radio-select",
                                  dis: ""
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('product.externalCodesMode_QuantityOfCustomers')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode("small", _hoisted_223, _toDisplayString(_ctx.$t('product.externalCodesMode_QuantityOfCustomers_Description')), 1)
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock("div", _hoisted_224, [
                            _createVNode("div", _hoisted_225, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('product.externalCodesModeTitle')), 1),
                              _hoisted_226,
                              (_ctx.product.externalCodesMode == 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_227, _toDisplayString(_ctx.$t('product.externalCodesMode_OnePerProduct')), 1))
                                : (_openBlock(), _createBlock("span", _hoisted_228, _toDisplayString(_ctx.$t('product.externalCodesMode_QuantityOfCustomers')), 1))
                            ])
                          ]))
                    ])
                  ])
                ]),
                _hoisted_229,
                _createVNode("div", _hoisted_230, [
                  _createVNode("div", null, [
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_231, [
                          _createVNode("div", _hoisted_232, [
                            _createVNode("div", _hoisted_233, [
                              (_ctx.editMode)
                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 0,
                                    type: "checkbox",
                                    class: "toggle",
                                    checked: _ctx.product.receiveAutoOrderNotificationMessages,
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.product.receiveAutoOrderNotificationMessages = $event)),
                                    onClick: _cache[59] || (_cache[59] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateReceiveAutoOrderNotifications && _ctx.disactivateOrActivateReceiveAutoOrderNotifications(...args)), ["stop"]))
                                  }, null, 8, ["checked"])), [
                                    [_vModelCheckbox, _ctx.product.receiveAutoOrderNotificationMessages]
                                  ])
                                : _createCommentVNode("", true),
                              _createVNode("span", _hoisted_234, _toDisplayString(_ctx.$t('sms-email-management.product.notification-via')) + ":", 1)
                            ]),
                            _withDirectives(_createVNode("div", null, [
                              _createVNode("span", {
                                style: {"top":"0!important"},
                                onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.addAutoOrderNotificationItem())),
                                class: "icon dark-circled-plus"
                              })
                            ], 512), [
                              [_vShow, _ctx.product.receiveAutoOrderNotificationMessages]
                            ])
                          ]),
                          (_ctx.product.receiveAutoOrderNotificationMessages)
                            ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_235, [
                                _createVNode("div", _hoisted_236, [
                                  _createVNode("div", null, _toDisplayString(_ctx.$t('sms-email-management.template.template-name')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.$t('sms-email-management.product.interval')), 1)
                                ]),
                                _createVNode("div", _hoisted_237, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productAutoOrderNotificationMessages, (orderNotification, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "order-notification-row",
                                      key: index
                                    }, [
                                      _createVNode("div", null, [
                                        _createVNode(_component_Multiselect, {
                                          class: [{
                                                                    'form-controll-multiselect': !orderNotification.messageTemplateId
                                                                }, "custom-multiselect-input custom-multiselect-input-auto-notifications"],
                                          "data-tab": _ctx.productDetailSections.Details,
                                          canDeselect: false,
                                          modelValue: orderNotification.messageTemplateId,
                                          "onUpdate:modelValue": ($event: any) => (orderNotification.messageTemplateId = $event),
                                          valueProp: "id",
                                          label: "name",
                                          trackBy: "name",
                                          options: _ctx.messageTemplates,
                                          searchable: false,
                                          "close-on-select": true,
                                          "open-direction": "'top'",
                                          placeholder: _ctx.$t('sms-email-management.template.template-name'),
                                          required: ""
                                        }, {
                                          caret: _withId(() => [
                                            _hoisted_238
                                          ]),
                                          _: 2
                                        }, 1032, ["class", "data-tab", "modelValue", "onUpdate:modelValue", "options", "placeholder"])
                                      ]),
                                      _createVNode("div", null, [
                                        _createVNode(_component_InputNumber, {
                                          class: [{
                                                                    'form-controll-multiselect': !orderNotification.intervalMinutes
                                                                }, "InputNumber-intervalMinutes form-controll"],
                                          "data-tab": _ctx.productDetailSections.Details,
                                          modelValue: orderNotification.intervalMinutes,
                                          "onUpdate:modelValue": ($event: any) => (orderNotification.intervalMinutes = $event),
                                          allowEmpty: true,
                                          required: ""
                                        }, null, 8, ["class", "data-tab", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createVNode("div", null, [
                                        _createVNode(_component_Multiselect, {
                                          modelValue: orderNotification.intervalTimeType,
                                          "onUpdate:modelValue": ($event: any) => (orderNotification.intervalTimeType = $event),
                                          valueProp: "id",
                                          label: "name",
                                          trackBy: "name",
                                          options: _ctx.orderBlockTypes,
                                          searchable: false,
                                          "close-on-select": true,
                                          canDeselect: false,
                                          class: "custom-multiselect-input custom-multiselect-input-auto-notifications",
                                          placeholder: _ctx.$t('sms-email-management.product.interval')
                                        }, {
                                          caret: _withId(() => [
                                            _hoisted_239
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                                      ]),
                                      _createVNode("div", null, [
                                        _createVNode(_component_Multiselect, {
                                          modelValue: orderNotification.intervalType,
                                          "onUpdate:modelValue": ($event: any) => (orderNotification.intervalType = $event),
                                          valueProp: "id",
                                          label: "name",
                                          trackBy: "name",
                                          options: _ctx.productAutoOrderNotificationTypes,
                                          searchable: false,
                                          "close-on-select": true,
                                          canDeselect: false,
                                          class: "custom-multiselect-input custom-multiselect-input-auto-notifications",
                                          placeholder: _ctx.$t('sms-email-management.product.interval-type')
                                        }, {
                                          caret: _withId(() => [
                                            _hoisted_240
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                                      ]),
                                      _createVNode("div", null, [
                                        _createVNode("i", {
                                          class: "icon-f icon-remove-circle pr4",
                                          onClick: ($event: any) => (_ctx.removeAutoOrderNotificationItem(index))
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ], 512)), [
                                [_vShow, 
                                                    _ctx.product.productAutoOrderNotificationMessages &&
                                                        _ctx.product.productAutoOrderNotificationMessages.length > 0
                                                ]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_241, [
                          _createVNode("span", _hoisted_242, _toDisplayString(_ctx.$t('sms-email-management.product.notification-via')) + ":", 1),
                          (_ctx.product.receiveAutoOrderNotificationMessages == false)
                            ? (_openBlock(), _createBlock("span", _hoisted_243, _toDisplayString(_ctx.$t('product.notActive')), 1))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_244, [
                            _createVNode("div", _hoisted_245, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productAutoOrderNotificationMessages, (orderNotification, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: index,
                                  class: "col-6 sms-email-auto-notification"
                                }, [
                                  _createVNode("div", _hoisted_246, [
                                    _createVNode("div", _hoisted_247, [
                                      _createVNode("span", _hoisted_248, _toDisplayString(_ctx.$t('sms-email-management.template.template-name')) + ": ", 1),
                                      _createVNode("span", _hoisted_249, _toDisplayString(_ctx.messageTemplates.find(x => x.id == orderNotification.messageTemplateId)
                                                                        ?.name), 1)
                                    ]),
                                    _createVNode("div", _hoisted_250, [
                                      _createVNode("span", _hoisted_251, _toDisplayString(_ctx.$t('sms-email-management.product.interval')) + ": ", 1),
                                      _createVNode("span", _hoisted_252, _toDisplayString(orderNotification.intervalMinutes) + " " + _toDisplayString(_ctx.$t(
                                                                            _ctx.orderBlockTypes.find(
                                                                                x => x.id == orderNotification.intervalTimeType
                                                                            ).name
                                                                        )) + " " + _toDisplayString(_ctx.$t(
                                                                            _ctx.productAutoOrderNotificationTypes.find(
                                                                                x => x.id == orderNotification.intervalType
                                                                            ).name
                                                                        )), 1)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                  ])
                ])
              ], 2)
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.Details]
            ]),
            _withDirectives(_createVNode("div", _hoisted_253, [
              _createVNode("div", _hoisted_254, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("p", {
                      key: 0,
                      class: ["upload-article last-upload-article px-lg-3", { 'product-faqs-empty-view': !_ctx.product.productFaqs.length && !_ctx.editMode }],
                      style: {"width":"100%","text-align":"start","font-size":"16px"}
                    }, _toDisplayString(_ctx.$t('product.faqInfo2')), 3))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_255, [
                  (_ctx.editMode && _ctx.product.productFaqs && _ctx.product.productFaqs.length < 20)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.addFAQ())),
                        type: "button",
                        class: "btn-add-general"
                      }, [
                        _hoisted_256,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('product.addNewQuestion')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_ProductFAQs, {
                  onDeleteFAQItem: _ctx.deleteFAQItem,
                  editMode: _ctx.editMode,
                  items: _ctx.product.productFaqs,
                  productId: _ctx.id
                }, null, 8, ["onDeleteFAQItem", "editMode", "items", "productId"])
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.FAQ]
            ]),
            _withDirectives(_createVNode("div", _hoisted_257, [
              _createVNode("div", {
                class: ["row py-3 px-md-3", { 'px-3': _ctx.editMode }]
              }, [
                _createVNode("div", _hoisted_258, [
                  _createVNode("span", _hoisted_259, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.productAddress')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_260, [
                        _withDirectives(_createVNode("input", {
                          placeholder: _ctx.$t('address.placeholder.address'),
                          "data-tab": _ctx.productDetailSections.Address,
                          required: "",
                          class: "bookit-input product-input form-control h48",
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.product.address = $event)),
                          maxlength: "100",
                          onChange: _cache[63] || (_cache[63] = ($event: any) => (_ctx.checkDescription('address')))
                        }, null, 40, ["placeholder", "data-tab"]), [
                          [_vModelText, _ctx.product.address]
                        ])
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_261, " " + _toDisplayString(_ctx.product.address), 1))
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_262, [
                      _createVNode("div", _hoisted_263, [
                        _createVNode("button", {
                          class: "btn-add-general",
                          onClick: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.routeToSelectLocation && _ctx.routeToSelectLocation(...args))),
                          style: {"margin":"0 auto"},
                          type: "button"
                        }, [
                          _hoisted_264,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('link.chooseLocationOnMap')), 1)
                        ])
                      ]),
                      (_ctx.product.longitude !== 0 && _ctx.product.latitude !== 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_265, [
                            _createVNode("div", _hoisted_266, null, 512)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_267, [
                        _createVNode("span", _hoisted_268, [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('product.country')) + ":", 1)
                        ]),
                        _createVNode("div", _hoisted_269, [
                          _createVNode(_component_Multiselect, _mergeProps({
                            class: { 'form-controll-multiselect': !_ctx.product.countryId },
                            required: "",
                            "data-tab": _ctx.productDetailSections.Address,
                            canDeselect: false,
                            modelValue: _ctx.product.countryId,
                            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.product.countryId = $event))
                          }, _ctx.countrySelect, { class: "custom-multiselect-input" }), {
                            caret: _withId(() => [
                              _hoisted_270
                            ]),
                            _: 1
                          }, 16, ["class", "data-tab", "modelValue"]),
                          (_ctx.product.countryId)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.product.countryId = null)),
                                class: "marker-remove",
                                style: {"padding-inline-end":"15px"}
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createVNode("input", {
                          required: "",
                          class: "d-none",
                          "data-tab": _ctx.productDetailSections.Address,
                          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.product.countryId = $event))
                        }, null, 8, ["data-tab"]), [
                          [_vModelText, _ctx.product.countryId]
                        ]),
                        _createVNode("span", _hoisted_271, [
                          _hoisted_272,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _hoisted_273
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_274, [
                      (_ctx.product.longitude !== 0 && _ctx.product.latitude !== 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_275, [
                            _hoisted_276,
                            _createVNode("div", _hoisted_277, null, 512)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("span", _hoisted_278, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('product.country')) + ":", 1)
                      ]),
                      _createVNode("span", _hoisted_279, [
                        _hoisted_280,
                        (_ctx.product && _ctx.product.country)
                          ? (_openBlock(), _createBlock("span", _hoisted_281, _toDisplayString(_ctx.product.country.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])),
                _createVNode("div", {
                  class: ["col-12", { 'col-md-6': _ctx.editMode }]
                }, [
                  _createVNode("span", _hoisted_282, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.city')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_283, [
                        _createVNode("div", _hoisted_284, [
                          _createVNode(_component_Multiselect, _mergeProps({
                            class: { 'form-controll-multiselect': !_ctx.product.cityId },
                            required: "",
                            "data-tab": _ctx.productDetailSections.Address,
                            canDeselect: false,
                            modelValue: _ctx.product.cityId,
                            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => (_ctx.product.cityId = $event))
                          }, _ctx.citySelect, { class: "custom-multiselect-input" }), {
                            caret: _withId(() => [
                              _hoisted_285
                            ]),
                            _: 1
                          }, 16, ["class", "data-tab", "modelValue"]),
                          (_ctx.product.cityId)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.product.cityId = null)),
                                class: "marker-remove"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createVNode("input", {
                          required: "",
                          class: "d-none",
                          "data-tab": _ctx.productDetailSections.Address,
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (_ctx.product.cityId = $event))
                        }, null, 8, ["data-tab"]), [
                          [_vModelText, _ctx.product.cityId]
                        ]),
                        _createVNode("span", _hoisted_286, [
                          _hoisted_287,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _hoisted_288
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_289, [
                        _hoisted_290,
                        (_ctx.product && _ctx.product.city)
                          ? (_openBlock(), _createBlock("span", _hoisted_291, _toDisplayString(_ctx.product.city.name), 1))
                          : _createCommentVNode("", true)
                      ]))
                ], 2),
                _createVNode("div", {
                  class: ["col-12", { 'col-md-6': _ctx.editMode }]
                }, [
                  _createVNode("span", _hoisted_292, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.region')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_293, [
                        _createVNode("div", _hoisted_294, [
                          _createVNode(_component_Multiselect, _mergeProps({
                            class: { 'form-controll-multiselect': !_ctx.product.regionId },
                            required: "",
                            "data-tab": _ctx.productDetailSections.Address,
                            canDeselect: false,
                            modelValue: _ctx.product.regionId,
                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (_ctx.product.regionId = $event))
                          }, _ctx.addressRegionSelect, { class: "custom-multiselect-input" }), {
                            caret: _withId(() => [
                              _hoisted_295
                            ]),
                            _: 1
                          }, 16, ["class", "data-tab", "modelValue"]),
                          (_ctx.product.regionId)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.product.regionId = null)),
                                class: "marker-remove"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createVNode("input", {
                          required: "",
                          class: "d-none",
                          "data-tab": _ctx.productDetailSections.Address,
                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_ctx.product.regionId = $event))
                        }, null, 8, ["data-tab"]), [
                          [_vModelText, _ctx.product.regionId]
                        ]),
                        _createVNode("span", _hoisted_296, [
                          _hoisted_297,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _hoisted_298
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_299, [
                        _hoisted_300,
                        (_ctx.product && _ctx.product.region)
                          ? (_openBlock(), _createBlock("span", _hoisted_301, _toDisplayString(_ctx.product.region.name), 1))
                          : _createCommentVNode("", true)
                      ]))
                ], 2),
                _createVNode("div", _hoisted_302, [
                  _createVNode("span", _hoisted_303, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('address.arrival.instructions')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.routeToEdit('arrivalInstructions')))
                        }, [
                          _hoisted_304
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_305, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "arrivalInstructions",
                          class: "bookit-textarea product-textarea resize-off long-description form-control",
                          "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.product.arrivalInstructions = $event)),
                          maxlength: "300",
                          onChange: _cache[76] || (_cache[76] = ($event: any) => (_ctx.checkDescription('arrival')))
                        }, null, 544), [
                          [_vModelText, _ctx.product.arrivalInstructions]
                        ]),
                        _createVNode("span", _hoisted_306, [
                          _createVNode("span", {
                            class: {
                                                    'length-limit':
                                                        (_ctx.product.arrivalInstructions ? _ctx.product.arrivalInstructions.length : 0) > 299
                                                }
                          }, _toDisplayString(_ctx.product.arrivalInstructions ? _ctx.product.arrivalInstructions.length : 0), 3),
                          _hoisted_307
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", {
                        key: 1,
                        style: {"padding-inline-end":"30px"},
                        class: ["product-field-value pb-3", _ctx.arrivalInstructionsExpanded ? 'text-expanded' : 'text-not-expanded']
                      }, _toDisplayString(_ctx.product.arrivalInstructions), 3))
                ]),
                _createVNode("div", {
                  class: ["col-12", { 'pt-3': _ctx.editMode }]
                }, [
                  _createVNode("span", _hoisted_308, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('address.parking.instructions')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.routeToEdit('parkingInstructions')))
                        }, [
                          _hoisted_309
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_310, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "parkingInstructions",
                          class: "bookit-textarea product-textarea resize-off long-description form-control",
                          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.product.parkingInstructions = $event)),
                          maxlength: "300",
                          onChange: _cache[79] || (_cache[79] = ($event: any) => (_ctx.checkDescription('parking')))
                        }, null, 544), [
                          [_vModelText, _ctx.product.parkingInstructions]
                        ]),
                        _createVNode("span", _hoisted_311, [
                          _createVNode("span", {
                            class: {
                                                    'length-limit':
                                                        (_ctx.product.parkingInstructions ? _ctx.product.parkingInstructions.length : 0) > 299
                                                }
                          }, _toDisplayString(_ctx.product.parkingInstructions ? _ctx.product.parkingInstructions.length : 0), 3),
                          _hoisted_312
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", {
                        key: 1,
                        style: {"padding-inline-end":"30px"},
                        class: ["product-field-value", _ctx.parkingInstructionsExpanded ? 'text-expanded' : 'text-not-expanded']
                      }, _toDisplayString(_ctx.product.parkingInstructions), 3))
                ], 2)
              ], 2)
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.Address]
            ]),
            _withDirectives(_createVNode("div", _hoisted_313, [
              _createVNode("div", _hoisted_314, [
                _createVNode(_component_ProductMoreInfo, {
                  onAddCustomInfoType: _ctx.addCustomInfoType,
                  onRemoveCustomInfoType: _ctx.removeCustomInfoType,
                  editMode: _ctx.editMode,
                  items: _ctx.product.productInfos,
                  productId: _ctx.product.id
                }, null, 8, ["onAddCustomInfoType", "onRemoveCustomInfoType", "editMode", "items", "productId"])
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.MoreInfo]
            ]),
            _withDirectives(_createVNode("div", _hoisted_315, [
              _createVNode("div", _hoisted_316, [
                _createVNode(_Transition, { name: "help" }, {
                  default: _withId(() => [
                    (_ctx.showproductActivityTimeDurationInfo)
                      ? (_openBlock(), _createBlock("div", _hoisted_317, [
                          _createVNode("small", _hoisted_318, _toDisplayString(_ctx.$t('help.aboutProductTime&Duration')), 1),
                          _createVNode("i", {
                            onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.showproductActivityTimeDurationInfo = !_ctx.showproductActivityTimeDurationInfo)),
                            class: "icon-f icon-arrow-back fs-28"
                          })
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_319, [
                          _createVNode("div", _hoisted_320, [
                            _createVNode("i", {
                              class: "icon-f icon-info fs-20 info-icon info-icon-time-duration",
                              onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.showproductActivityTimeDurationInfo = !_ctx.showproductActivityTimeDurationInfo))
                            }),
                            _createVNode("div", _hoisted_321, [
                              _createVNode("div", _hoisted_322, [
                                _createVNode(_component_router_link, {
                                  style: {"width":"fit-content"},
                                  class: "btn-add-general",
                                  to: { name: 'CalendarV3', query: { product: _ctx.product.id, new: 'slot' } },
                                  target: "_blank"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_323,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('calendar.v3.opencalendar')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"])
                              ]),
                              _createVNode("div", _hoisted_324, [
                                _createVNode("div", _hoisted_325, [
                                  _createVNode("div", _hoisted_326, [
                                    _createVNode("button", {
                                      style: {"padding":"5px 16px"},
                                      type: "button",
                                      class: !_ctx.showFilter ? 'filter-btn' : 'filter-btn-pressed',
                                      onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
                                      _hoisted_327
                                    ], 2)
                                  ])
                                ]),
                                _createVNode("div", _hoisted_328, [
                                  _createVNode("div", _hoisted_329, [
                                    (_ctx.showAllSlots)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.showAllSlots = false))
                                        }, _toDisplayString(_ctx.$t('button.showAll')), 1))
                                      : (_openBlock(), _createBlock("span", {
                                          key: 1,
                                          onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.showAllSlots = true))
                                        }, "Show Future"))
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode(_component_ProductSlotsTable, {
                              slots: _ctx.futureSlots,
                              "edit-mode": _ctx.editMode,
                              showFilter: _ctx.showFilter,
                              onOpen: _ctx.openSlot
                            }, null, 8, ["slots", "edit-mode", "showFilter", "onOpen"])
                          ])
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_CalendarSlotModal, {
                  products: [],
                  showProduct: false,
                  ref: "modalSlot",
                  onSave: _ctx.updateSlot
                }, null, 8, ["onSave"])
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.TimeAndDuration]
            ]),
            _withDirectives(_createVNode("div", _hoisted_330, [
              _createVNode("div", null, [
                _createVNode(_Transition, { name: "help" }, {
                  default: _withId(() => [
                    (_ctx.showProductPhotosVideoInfo)
                      ? (_openBlock(), _createBlock("div", _hoisted_331, [
                          _createVNode("div", _hoisted_332, [
                            _createVNode("a", _hoisted_333, _toDisplayString(_ctx.$t('help.watchTheVideo')), 1)
                          ]),
                          _createVNode("small", _hoisted_334, _toDisplayString(_ctx.$t('help.aboutProductPhotosVideo')), 1),
                          _createVNode("i", {
                            onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.showProductPhotosVideoInfo = !_ctx.showProductPhotosVideoInfo)),
                            class: "icon-f icon-arrow-back fs-28"
                          })
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_335, [
                          (_ctx.editMode)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                class: "icon-f icon-info fs-20 info-icon",
                                style: {"z-index":"2"},
                                onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.showProductPhotosVideoInfo = !_ctx.showProductPhotosVideoInfo))
                              }))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_336, [
                            _createVNode("div", _hoisted_337, [
                              (_ctx.editMode)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createVNode("div", _hoisted_338, [
                                      _createVNode("button", {
                                        class: ["btn browse-photo browse-button green-button", 
                                                                _ctx.product && _ctx.product.productImages && _ctx.product.productImages.length >= 20
                                                                    ? 'images-limit-reached'
                                                                    : ''
                                                            ],
                                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.startUploadImage($event, 'image-upload-input'))),
                                        style: {"margin":"0 auto"},
                                        type: "button"
                                      }, [
                                        _createVNode("input", {
                                          type: "file",
                                          name: "",
                                          id: "image-upload-input",
                                          style: {"display":"none"},
                                          onChange: _cache[87] || (_cache[87] = ($event: any) => (_ctx.uploadingImageValidation($event, false))),
                                          accept: "image/*"
                                        }, null, 32),
                                        _hoisted_339,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('product.browsePhoto')), 1)
                                      ], 2)
                                    ]),
                                    _createVNode("p", _hoisted_340, _toDisplayString(_ctx.$t('product.supportedFiles')), 1),
                                    _createVNode("p", {
                                      class: ["upload-article", 
                                                            _ctx.product.productImages && _ctx.product.productImages.length == 0
                                                                ? 'last-upload-article'
                                                                : ''
                                                        ]
                                    }, _toDisplayString(_ctx.$t('product-page-edit.photos-videos.5mb-size')), 3),
                                    (_ctx.product.productImages && _ctx.product.productImages.length > 0)
                                      ? (_openBlock(), _createBlock("p", {
                                          key: 0,
                                          class: ["upload-article", 
                                                            _ctx.product.productImages && _ctx.product.productImages.length > 0
                                                                ? 'last-upload-article'
                                                                : ''
                                                        ]
                                        }, _toDisplayString(_ctx.$t('product-page-edit.photos-videos.dragPhoto')), 3))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_341, [
                                      _createVNode("div", _hoisted_342, [
                                        (_ctx.imgSrc)
                                          ? (_openBlock(), _createBlock("div", _hoisted_343, [
                                              _createVNode(_component_cropper, {
                                                ref: "cropperLib",
                                                class: "cropper",
                                                src: _ctx.imgSrc,
                                                "stencil-props": {
                                                                        aspectRatio: 10 / 12
                                                                    }
                                              }, null, 8, ["src"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.imgSrc)
                                          ? (_openBlock(), _createBlock("div", _hoisted_344, [
                                              _createVNode("div", _hoisted_345, [
                                                _createVNode("div", _hoisted_346, [
                                                  _createVNode("div", _hoisted_347, [
                                                    _createVNode("button", {
                                                      type: "button",
                                                      class: "btn save-image-btn browse-photo green-button mt-4",
                                                      onClick: _cache[89] || (_cache[89] = 
//@ts-ignore
(...args) => (_ctx.saveImage && _ctx.saveImage(...args)))
                                                    }, _toDisplayString(_ctx.$t('button.save')), 1)
                                                  ]),
                                                  _createVNode("div", _hoisted_348, [
                                                    _createVNode("button", {
                                                      type: "button",
                                                      class: "clear-image-btn btn browse-photo gray-button mt-4",
                                                      onClick: _cache[90] || (_cache[90] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                                                    }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_ctx.product.productImages)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    class: ["mx-auto col-12 col-lg-11 images-order", { 'pt-3': !_ctx.editMode }]
                                  }, [
                                    _createVNode(_component_draggable, {
                                      modelValue: _ctx.product.productImages,
                                      "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.product.productImages = $event)),
                                      group: "images",
                                      onStart: _cache[92] || (_cache[92] = ($event: any) => (_ctx.drag = true)),
                                      onEnd: _cache[93] || (_cache[93] = ($event: any) => (_ctx.drag = false)),
                                      "item-key": "id",
                                      class: "row",
                                      style: {"margin":"0"}
                                    }, _createSlots({
                                      item: _withId(({element, index}) => [
                                        _createVNode("div", {
                                          class: ["col-4 col-md-2 photo-container", { pointer: _ctx.editMode }]
                                        }, [
                                          (element.id)
                                            ? (_openBlock(), _createBlock("div", _hoisted_349, [
                                                (element.isMainImage)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_350))
                                                  : _createCommentVNode("", true),
                                                _createVNode("img", {
                                                  src: element.pathSmall,
                                                  alt: element.name,
                                                  onClick: ($event: any) => (_ctx.showImageSettings(index))
                                                }, null, 8, ["src", "alt", "onClick"]),
                                                _createVNode("ul", {
                                                  class: "dropdown-menu",
                                                  id: index + '-image-dropdown-settings'
                                                }, [
                                                  _createVNode("li", {
                                                    onClick: ($event: any) => (_ctx.routeToEditFile(element.id, 'image'))
                                                  }, _toDisplayString(_ctx.$t('button.edit')), 9, ["onClick"]),
                                                  (!element.isMainImage)
                                                    ? (_openBlock(), _createBlock("li", {
                                                        key: 0,
                                                        onClick: ($event: any) => (_ctx.makeImageAsMain(element.id))
                                                      }, [
                                                        _createVNode("a", _hoisted_351, _toDisplayString(_ctx.$t('button.setAsCover')), 1)
                                                      ], 8, ["onClick"]))
                                                    : _createCommentVNode("", true),
                                                  _createVNode("li", {
                                                    onClick: ($event: any) => (_ctx.removeImageFromProduct(element.id))
                                                  }, [
                                                    _createVNode("a", _hoisted_352, _toDisplayString(_ctx.$t('button.delete')), 1)
                                                  ], 8, ["onClick"])
                                                ], 8, ["id"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, [
                                      (_ctx.product.productImages > 6)
                                        ? {
                                            name: "footer",
                                            fn: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(6 - _ctx.product.productImages.length, (index) => {
                                                return (_openBlock(), _createBlock("div", {
                                                  class: "col-4 col-md-2 photo-container pointer",
                                                  key: index
                                                }, [
                                                  _hoisted_353
                                                ]))
                                              }), 128))
                                            ])
                                          }
                                        : undefined
                                    ]), 1032, ["modelValue"])
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_354,
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_355, [
                                  _createVNode("div", _hoisted_356, [
                                    _createVNode("p", null, _toDisplayString(_ctx.$t('product.clickOnThePhoto')), 1),
                                    _createVNode("p", null, _toDisplayString(_ctx.$t('product-page-edit.photos-videos.allow20')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_357, [
                            _createVNode("div", _hoisted_358, [
                              (!_ctx.product.ticketImagePath || !_ctx.product.ticketImagePathSmall)
                                ? (_openBlock(), _createBlock("div", _hoisted_359, [
                                    _createVNode("div", _hoisted_360, [
                                      _createVNode("div", _hoisted_361, [
                                        _createVNode("div", _hoisted_362, _toDisplayString(_ctx.$t('ticket.productPage.title')), 1)
                                      ]),
                                      (_ctx.editMode)
                                        ? (_openBlock(), _createBlock("div", _hoisted_363, [
                                            _createVNode("span", {
                                              style: {"top":"0!important"},
                                              onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.startUploadImage($event, 'ticket-image-upload-input'))),
                                              class: "icon dark-circled-plus"
                                            }, [
                                              _createVNode("input", {
                                                type: "file",
                                                name: "",
                                                id: "ticket-image-upload-input",
                                                style: {"display":"none"},
                                                onChange: _cache[94] || (_cache[94] = ($event: any) => (_ctx.uploadingTicketImageValidation($event))),
                                                accept: "image/*"
                                              }, null, 32)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_364, [
                                _createVNode("div", _hoisted_365, [
                                  (_ctx.ticketImgSrc)
                                    ? (_openBlock(), _createBlock("div", _hoisted_366, [
                                        _createVNode(_component_cropper, {
                                          ref: "cropperLib",
                                          class: "cropper",
                                          src: _ctx.ticketImgSrc,
                                          "stencil-props": {
                                                                    aspectRatio: 157 / 63
                                                                }
                                        }, null, 8, ["src"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.ticketImgSrc)
                                    ? (_openBlock(), _createBlock("div", _hoisted_367, [
                                        _createVNode("div", _hoisted_368, [
                                          _createVNode("div", _hoisted_369, [
                                            _createVNode("div", _hoisted_370, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "btn save-image-btn browse-photo green-button mt-4",
                                                onClick: _cache[96] || (_cache[96] = 
//@ts-ignore
(...args) => (_ctx.saveTicketImage && _ctx.saveTicketImage(...args)))
                                              }, _toDisplayString(_ctx.$t('button.save')), 1)
                                            ]),
                                            _createVNode("div", _hoisted_371, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "clear-image-btn btn browse-photo gray-button mt-4",
                                                onClick: _cache[97] || (_cache[97] = 
//@ts-ignore
(...args) => (_ctx.clearTicketImage && _ctx.clearTicketImage(...args)))
                                              }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.product.ticketImagePath || _ctx.product.ticketImagePathSmall)
                                ? (_openBlock(), _createBlock("div", _hoisted_372, [
                                    _createVNode("div", _hoisted_373, [
                                      _createVNode("div", _hoisted_374, [
                                        _createVNode("div", _hoisted_375, [
                                          _createVNode("div", _hoisted_376, [
                                            _createVNode("img", {
                                              src: _ctx.product.ticketImagePath ?? ''
                                            }, null, 8, ["src"])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_377, [
                                          _createVNode("div", _hoisted_378, [
                                            _createVNode("img", {
                                              src: _ctx.product.ticketImagePathSmall ?? ''
                                            }, null, 8, ["src"])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    (_ctx.editMode)
                                      ? (_openBlock(), _createBlock("div", _hoisted_379, [
                                          _createVNode("span", {
                                            style: {"top":"0!important"},
                                            onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.startUploadImage($event, 'ticket-image-upload-input'))),
                                            class: "dark-squared"
                                          }, [
                                            _hoisted_380,
                                            _createVNode("input", {
                                              type: "file",
                                              name: "",
                                              id: "ticket-image-upload-input",
                                              style: {"display":"none"},
                                              onChange: _cache[98] || (_cache[98] = ($event: any) => (_ctx.uploadingTicketImageValidation($event))),
                                              accept: "image/*"
                                            }, null, 32)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _hoisted_381,
                          _createVNode("div", _hoisted_382, [
                            _createVNode("div", _hoisted_383, [
                              _createVNode("div", _hoisted_384, [
                                (_ctx.editMode)
                                  ? (_openBlock(), _createBlock("div", _hoisted_385, [
                                      _createVNode("button", {
                                        class: "btn browse-photo green-button",
                                        type: "button",
                                        onClick: _cache[100] || (_cache[100] = 
//@ts-ignore
(...args) => (_ctx.addYoutubeInput && _ctx.addYoutubeInput(...args)))
                                      }, [
                                        _hoisted_386,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('product.addMovie')), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode("div", _hoisted_387, [
                                  _createVNode("span", _hoisted_388, _toDisplayString(_ctx.$t('product.addVideo')), 1)
                                ]),
                                (_ctx.editMode)
                                  ? (_openBlock(), _createBlock("div", _hoisted_389, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productVideos, (videoLink, i) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "video-link col-12",
                                          key: videoLink.id
                                        }, [
                                          _createVNode("div", _hoisted_390, [
                                            _createVNode("div", _hoisted_391, [
                                              _withDirectives(_createVNode("input", {
                                                id: `${videoLink.id}-${i}`,
                                                type: "text",
                                                class: "bookit-input product-input",
                                                "onUpdate:modelValue": ($event: any) => (videoLink.path = $event)
                                              }, null, 8, ["id", "onUpdate:modelValue"]), [
                                                [_vModelText, videoLink.path]
                                              ])
                                            ]),
                                            _createVNode("div", _hoisted_392, [
                                              _createVNode("span", {
                                                class: "icon pointer",
                                                onClick: ($event: any) => (_ctx.removeYouTubeLink(i))
                                              }, [
                                                _hoisted_393
                                              ], 8, ["onClick"])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_394, [
                                      (_ctx.product.productVideos && _ctx.product.productVideos.length > 0)
                                        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.product.productVideos, (video, i) => {
                                            return (_openBlock(), _createBlock("div", {
                                              class: "video-link row mx-auto col-12",
                                              key: i
                                            }, [
                                              _createVNode("div", _hoisted_395, [
                                                _createVNode("a", {
                                                  class: "product-text product-text-link",
                                                  href: video.path,
                                                  target: "_blank"
                                                }, _toDisplayString(video.path), 9, ["href"])
                                              ])
                                            ]))
                                          }), 128))
                                        : (_openBlock(), _createBlock("div", _hoisted_396, [
                                            _hoisted_397,
                                            _hoisted_398,
                                            _createVNode("p", _hoisted_399, _toDisplayString(_ctx.$t('product.emptyVideoLabel')), 1)
                                          ]))
                                    ]))
                              ])
                            ])
                          ])
                        ]))
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.PhotosAndVideo]
            ]),
            _withDirectives(_createVNode("div", _hoisted_400, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock(_Transition, {
                    key: 0,
                    name: "help"
                  }, {
                    default: _withId(() => [
                      (_ctx.showDocumentsHelp)
                        ? (_openBlock(), _createBlock("div", _hoisted_401, [
                            _createVNode("small", _hoisted_402, _toDisplayString(_ctx.$t('help.aboutProductPhotosVideo')), 1),
                            _createVNode("i", {
                              onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.showDocumentsHelp = !_ctx.showDocumentsHelp)),
                              class: "icon-f icon-arrow-back fs-28"
                            })
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_403, [
                            _createVNode("i", {
                              class: "icon-f icon-info fs-20 info-icon",
                              style: {"z-index":"2"},
                              onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.showDocumentsHelp = !_ctx.showDocumentsHelp))
                            }),
                            _createVNode("div", _hoisted_404, [
                              _createVNode("div", _hoisted_405, [
                                _createVNode("div", _hoisted_406, [
                                  _createVNode("button", {
                                    class: "btn-add-general mb-3",
                                    type: "button",
                                    onClick: _cache[104] || (_cache[104] = 
//@ts-ignore
(...args) => (_ctx.callUploadingFunction && _ctx.callUploadingFunction(...args)))
                                  }, [
                                    _createVNode("input", {
                                      type: "file",
                                      name: "file-upload-input",
                                      id: "file-upload-input",
                                      style: {"display":"none"},
                                      onChange: _cache[103] || (_cache[103] = 
//@ts-ignore
(...args) => (_ctx.uploadingFileValidation && _ctx.uploadingFileValidation(...args)))
                                    }, null, 32),
                                    _hoisted_407,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('product.browseFile')), 1)
                                  ]),
                                  _createVNode("div", null, _toDisplayString(_ctx.$t('product.forExampleInsurance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.$t('product.about-documents-formats')), 1)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_408, [
                              _createVNode("div", _hoisted_409, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productDocuments, (document, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "col-4 document-container",
                                    key: document.id
                                  }, [
                                    _createVNode("div", {
                                      class: "document-wrapper",
                                      onClick: ($event: any) => (_ctx.showDocumentSettings(index))
                                    }, [
                                      _createVNode("a", {
                                        target: "_blank",
                                        href: document.path,
                                        class: "file-link"
                                      }, _toDisplayString(document.name), 9, ["href"]),
                                      _createVNode("i", {
                                        class: [_ctx.getDocIcon(document.name), "icon-f fs-24"]
                                      }, null, 2),
                                      _createVNode("ul", {
                                        class: "dropdown-menu",
                                        id: index + '-document-dropdown-settings'
                                      }, [
                                        _createVNode("li", {
                                          onClick: ($event: any) => (_ctx.routeToEditFile(document.id, 'document'))
                                        }, _toDisplayString(_ctx.$t('button.edit')), 9, ["onClick"]),
                                        _createVNode("li", {
                                          onClick: ($event: any) => (_ctx.deleteDocument(document))
                                        }, [
                                          _createVNode("span", _hoisted_410, _toDisplayString(_ctx.$t('button.delete')), 1)
                                        ], 8, ["onClick"])
                                      ], 8, ["id"])
                                    ], 8, ["onClick"])
                                  ]))
                                }), 128)),
                                (_ctx.product.productDocuments && _ctx.product.productDocuments.length < 6)
                                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(6 - _ctx.product.productDocuments.length, (index) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "col-4 document-container",
                                        key: index
                                      }, [
                                        _hoisted_411
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    (_ctx.product.productDocuments && _ctx.product.productDocuments.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_412, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productDocuments, (document) => {
                            return (_openBlock(), _createBlock("a", {
                              class: "col-4 col-md-2 document-container",
                              key: document.id,
                              target: "_blank",
                              href: document.path
                            }, [
                              _createVNode("div", _hoisted_413, [
                                _createVNode("p", _hoisted_414, _toDisplayString(document.name), 1),
                                _hoisted_415
                              ])
                            ], 8, ["href"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_416, [
                          _createVNode("span", null, [
                            _hoisted_417,
                            _hoisted_418,
                            _createVNode("span", _hoisted_419, _toDisplayString(_ctx.$t('product.emptyDocumentLabel')), 1)
                          ])
                        ]))
                  ], 64))
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.Documents]
            ]),
            _withDirectives(_createVNode("div", _hoisted_420, [
              _createVNode("div", null, [
                _createVNode("div", {
                  class: ["pt-3", _ctx.product.productPrices.length > 0 ? 'margin-bottom12' : '']
                }, [
                  _createVNode("div", _hoisted_421, [
                    _createVNode("div", _hoisted_422, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            class: "btn-add-general",
                            type: "button",
                            onClick: _cache[105] || (_cache[105] = 
//@ts-ignore
(...args) => (_ctx.createNewPricing && _ctx.createNewPricing(...args)))
                          }, [
                            _hoisted_423,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('product.newPriceList')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.product.productPrices.some(x => x.deletedAt != null))
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.showNotActivePrices = !_ctx.showNotActivePrices)),
                            class: "pointer text-center m-0 pb-0",
                            style: {"color":"#00bfdb","text-decoration":"underline"}
                          }, _toDisplayString(_ctx.showNotActivePrices
                                                        ? _ctx.$t('btn.hide-not-active-prices')
                                                        : _ctx.$t('btn.show-not-active-prices')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2),
                _createVNode("div", _hoisted_424, [
                  _createVNode("table", _hoisted_425, [
                    _createVNode("thead", null, [
                      _createVNode("tr", null, [
                        _createVNode("th", null, _toDisplayString(_ctx.$t('keyword.name')), 1),
                        _createVNode("th", null, _toDisplayString(_ctx.$t('priceList.date')), 1),
                        _createVNode("th", null, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                        _createVNode("th", null, _toDisplayString(_ctx.$t('product.price-type')), 1),
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("th", _hoisted_426))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productPrices.filter(
                                                    x => x.deletedAt == null || (x.deletedAt != null) == _ctx.showNotActivePrices
                                                ), (pricing) => {
                        return (_openBlock(), _createBlock("tr", {
                          class: { strikeout: pricing.deletedAt !== null },
                          key: pricing.id
                        }, [
                          _createVNode("td", _hoisted_427, _toDisplayString(pricing.title), 1),
                          _createVNode("td", _hoisted_428, _toDisplayString(_ctx.getDateToTitle(pricing.fromDate)) + " - " + _toDisplayString(_ctx.getDateToTitle(pricing.toDate)), 1),
                          _createVNode("td", _hoisted_429, _toDisplayString(_ctx.findCurrencySymbol(pricing.id)), 1),
                          _createVNode("td", _hoisted_430, _toDisplayString(_ctx.findPriceTypeName(pricing.id)), 1),
                          (_ctx.editMode)
                            ? (_openBlock(), _createBlock("td", _hoisted_431, [
                                _createVNode("span", null, [
                                  (pricing.deletedAt == null)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: {
                                                                name: 'product-price-list',
                                                                params: { productId: _ctx.productId, priceId: pricing.id, action: 'copy' }
                                                            }
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_432
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true),
                                  _createVNode("i", {
                                    class: "icon-f icon-pencil-edit fs-16",
                                    onClick: ($event: any) => (_ctx.routeToPriceListactions(_ctx.id, pricing.id))
                                  }, null, 8, ["onClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_433, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productPrices.filter(
                                            x => x.deletedAt == null || (x.deletedAt != null) == _ctx.showNotActivePrices
                                        ), (pricing, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "w-100 px-3",
                      key: pricing.id
                    }, [
                      (index < 3 || _ctx.showAllPrices)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "pricing-section",
                            style: `opacity: ${pricing.deletedAt !== null ? '0.6' : ''}`
                          }, [
                            _createVNode("div", _hoisted_434, [
                              _createVNode("div", _hoisted_435, [
                                _createVNode("span", _hoisted_436, _toDisplayString(_ctx.$t('keyword.name')), 1),
                                _createVNode("span", null, _toDisplayString(pricing.title), 1)
                              ]),
                              _createVNode("div", _hoisted_437, [
                                _createVNode("span", _hoisted_438, _toDisplayString(_ctx.$t('priceList.date')), 1),
                                _createVNode("span", null, _toDisplayString(_ctx.getDateToTitle(pricing.fromDate)), 1),
                                _hoisted_439,
                                _createVNode("span", null, _toDisplayString(_ctx.getDateToTitle(pricing.toDate)), 1)
                              ]),
                              _createVNode("div", _hoisted_440, [
                                _createVNode("span", _hoisted_441, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                                _createVNode("span", null, _toDisplayString(_ctx.findCurrencySymbol(pricing.id)), 1)
                              ]),
                              _createVNode("div", _hoisted_442, [
                                _createVNode("span", _hoisted_443, _toDisplayString(_ctx.$t('product.price-type')), 1),
                                _createVNode("span", null, _toDisplayString(_ctx.findPriceTypeName(pricing.id)), 1)
                              ]),
                              _createVNode("div", _hoisted_444, [
                                (pricing.deletedAt == null)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: {
                                                            name: 'product-price-list',
                                                            params: { productId: _ctx.productId, priceId: pricing.id, action: 'copy' }
                                                        }
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_445
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true),
                                _createVNode("i", {
                                  class: "icon-f icon-pencil-edit fs-16",
                                  onClick: ($event: any) => (_ctx.routeToPriceListactions(_ctx.id, pricing.id))
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ], 4))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                (
                                        _ctx.product.productPrices.filter(
                                            x => x.deletedAt == null || (x.deletedAt != null) == _ctx.showNotActivePrices
                                        ).length > 3
                                    )
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: _cache[107] || (_cache[107] = ($event: any) => (_ctx.showAllPrices = !_ctx.showAllPrices)),
                      class: ["pointer text-center m-0 d-block d-lg-none", { 'pt-3': _ctx.showAllPrices }],
                      style: {"color":"#00bfdb","text-decoration":"underline"}
                    }, _toDisplayString(_ctx.showAllPrices ? _ctx.$t('btn.show-less') : _ctx.$t('btn.show-more')), 3))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.Pricing]
            ]),
            (_ctx.product.id)
              ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_446, [
                  (_ctx.product.productsNotificationsRestrictions)
                    ? (_openBlock(), _createBlock("div", _hoisted_447, [
                        _createVNode(_component_NotificationsRestrictions, {
                          productId: _ctx.product.id,
                          restrictions: _ctx.product.productsNotificationsRestrictions,
                          editMode: _ctx.editMode
                        }, null, 8, ["productId", "restrictions", "editMode"])
                      ]))
                    : _createCommentVNode("", true)
                ], 512)), [
                  [_vShow, _ctx.tab == _ctx.productDetailSections.Notifications]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode("div", _hoisted_448, [
              _createVNode("div", _hoisted_449, [
                _createVNode("div", {
                  class: [_ctx.editMode ? 'col-12' : 'col-md-8', "col-12 product-details-general-left-side order-1"]
                }, [
                  _createVNode("div", _hoisted_450, [
                    _createVNode("span", {
                      class: { 'data-to-row': _ctx.editMode }
                    }, [
                      _createVNode("span", _hoisted_451, _toDisplayString(_ctx.$t('catalog.productHashId')) + ":", 1),
                      _createVNode("span", null, " " + _toDisplayString(_ctx.id), 1)
                    ], 2),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("span", _hoisted_452, [
                          _createVNode("span", _hoisted_453, _toDisplayString(_ctx.$t('product.active')) + ":", 1),
                          (_ctx.editMode)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 0,
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.product.active,
                                "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => (_ctx.product.active = $event)),
                                onClick: _cache[109] || (_cache[109] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateProduct && _ctx.disactivateOrActivateProduct(...args)), ["stop"]))
                              }, null, 8, ["checked"])), [
                                [_vModelCheckbox, _ctx.product.active]
                              ])
                            : (_openBlock(), _createBlock("p", {
                                key: 1,
                                class: [_ctx.product.active ? 'active' : 'not-active', "text-uppercase"]
                              }, _toDisplayString(_ctx.product.active ? _ctx.$t('product.active') : _ctx.$t('product.notActive')), 3))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_454, _toDisplayString(_ctx.$t('product.createdDate')) + ":", 1),
                    _createVNode("span", null, " " + _toDisplayString(_ctx.momentFormat(_ctx.product.createdAt, 'datetime')), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_455, _toDisplayString(_ctx.$t('calendar.v3.modal.block-creating-new-orders')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_456, [
                          _createVNode("div", _hoisted_457, [
                            _createVNode(_component_Multiselect, {
                              modelValue: _ctx.product.selectedOrderBlockOption,
                              "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => (_ctx.product.selectedOrderBlockOption = $event)),
                              valueProp: "id",
                              label: "name",
                              trackBy: "name",
                              options: _ctx.orderBlockOptions,
                              searchable: false,
                              "close-on-select": true,
                              canDeselect: false,
                              onInput: _ctx.watchAtOption,
                              class: "custom-multiselect-input"
                            }, {
                              caret: _withId(() => [
                                _hoisted_458
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "onInput"])
                          ]),
                          (_ctx.product.blockCreatingNewOrdersBefore)
                            ? (_openBlock(), _createBlock("div", _hoisted_459, [
                                _createVNode(_component_InputNumber, {
                                  class: [{ 'form-controll-multiselect': !_ctx.product.orderBlockMinutes }, "InputNumber-orderBlockMinutes form-controll"],
                                  "data-tab": _ctx.productDetailSections.General,
                                  required: "",
                                  modelValue: _ctx.product.orderBlockMinutes,
                                  "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => (_ctx.product.orderBlockMinutes = $event)),
                                  min: 0,
                                  allowEmpty: true
                                }, null, 8, ["class", "data-tab", "modelValue"]),
                                _createVNode("div", _hoisted_460, [
                                  _createVNode(_component_Multiselect, {
                                    modelValue: _ctx.product.selectedOrderBlockType,
                                    "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => (_ctx.product.selectedOrderBlockType = $event)),
                                    valueProp: "id",
                                    label: "name",
                                    trackBy: "name",
                                    options: _ctx.orderBlockTypes,
                                    searchable: false,
                                    "close-on-select": true,
                                    canDeselect: false,
                                    onChange: _cache[113] || (_cache[113] = ($event: any) => (_ctx.product.orderBlockMinutes = null)),
                                    class: "custom-multiselect-input"
                                  }, {
                                    caret: _withId(() => [
                                      _hoisted_461
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "options"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.product.orderBlockMinutes == null)
                        ? (_openBlock(), _createBlock("div", _hoisted_462, _toDisplayString(_ctx.$t('calendar.v3.modal.slot.allow')), 1))
                        : (_ctx.product.orderBlockMinutes === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_463, _toDisplayString(_ctx.$t('calendar.v3.modal.slot.after')), 1))
                          : (_openBlock(), _createBlock("div", _hoisted_464, _toDisplayString(_ctx.product.orderBlockMinutes +
                                                    ' ' +
                                                    _ctx.$t('calendar.v3.modal.slot.' + _ctx.orderBlockTypes[_ctx.product.selectedOrderBlockType].key)), 1))
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_465, [
                        _createVNode("div", _hoisted_466, [
                          _createVNode("span", _hoisted_467, _toDisplayString(_ctx.$t('catalog.order-limitation')), 1),
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => (_ctx.product.orderLimitation = $event)),
                            type: "text",
                            onKeypress: _cache[115] || (_cache[115] = ($event: any) => (_ctx.isNumber($event))),
                            onFocus: _cache[116] || (_cache[116] = ($event: any) => (
                                                    _ctx.product.orderLimitation = _ctx.product.orderLimitation == 0 ? '' : _ctx.product.orderLimitation
                                                )),
                            onBlur: _cache[117] || (_cache[117] = ($event: any) => (
                                                    _ctx.product.orderLimitation = _ctx.product.orderLimitation == '' ? 0 : _ctx.product.orderLimitation
                                                )),
                            style: {"width":"inherit","max-width":"130px"},
                            class: "bookit-input"
                          }, null, 544), [
                            [_vModelText, _ctx.product.orderLimitation]
                          ]),
                          _createVNode("span", _hoisted_468, _toDisplayString(_ctx.$t('label.tickets')), 1)
                        ])
                      ]))
                    : (_ctx.product.orderLimitation != null)
                      ? (_openBlock(), _createBlock("div", _hoisted_469, [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.order-limitation')), 1),
                          _createVNode("span", null, [
                            _createVNode("span", null, _toDisplayString(_ctx.formatAmountNoDecimal(_ctx.product.orderLimitation)) + " " + _toDisplayString(_ctx.$t('label.tickets')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ], 2),
                _createVNode("div", {
                  class: [_ctx.editMode ? 'col-12 pt-3' : 'col-md-4 pt-3 pt-md-0 product-details-general-right-side', "col-12 order-2"]
                }, [
                  _createVNode("div", {
                    class: { 'data-to-row': _ctx.editMode }
                  }, [
                    _createVNode("span", _hoisted_470, _toDisplayString(_ctx.$t('catalog.calendarColor')) + ":", 1),
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "color",
                          id: "color-picker-input",
                          class: "bookit-color-picker",
                          "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => (_ctx.product.calendarColor = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.product.calendarColor]
                        ])
                      : (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: "small-circle-status",
                          style: `background:${_ctx.product.calendarColor};`
                        }, null, 4))
                  ], 2),
                  (!_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_471, [
                        _createVNode("span", _hoisted_472, _toDisplayString(_ctx.$t('product.active')) + ":", 1),
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "checkbox",
                              class: "toggle",
                              checked: _ctx.product.active,
                              "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => (_ctx.product.active = $event)),
                              onClick: _cache[120] || (_cache[120] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateProduct && _ctx.disactivateOrActivateProduct(...args)), ["stop"]))
                            }, null, 8, ["checked"])), [
                              [_vModelCheckbox, _ctx.product.active]
                            ])
                          : (_openBlock(), _createBlock("p", {
                              key: 1,
                              class: [_ctx.product.active ? 'active' : 'not-active', "text-uppercase"]
                            }, _toDisplayString(_ctx.product.active ? _ctx.$t('product.active') : _ctx.$t('product.notActive')), 3))
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.priceTypes, (priceType) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-12 order-2 col-12 pt-3",
                    key: priceType.id
                  }, [
                    _createVNode("div", {
                      class: { 'data-to-row pt-3': _ctx.editMode }
                    }, [
                      _createVNode("span", _hoisted_473, _toDisplayString(_ctx.$t(
                                                    `product.canCreateSlotDuringCreatingOrder.${priceType.originName
                                                        .replace(' ', '')
                                                        .toLocaleLowerCase()}`
                                                )) + ":", 1),
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "checkbox",
                            class: "toggle",
                            value: priceType.id,
                            "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => (_ctx.product.availableProductPriceTypes = $event)),
                            onClick: _withModifiers(($event: any) => (_ctx.disactivateOrActivateProductPriceType($event, priceType.id)), ["stop"])
                          }, null, 8, ["value", "onClick"])), [
                            [_vModelCheckbox, _ctx.product.availableProductPriceTypes]
                          ])
                        : (_openBlock(), _createBlock("p", {
                            key: 1,
                            class: [_ctx.product.availableProductPriceTypes.includes(priceType.id) ? 'active' : 'not-active', "text-uppercase"]
                          }, _toDisplayString(_ctx.product.availableProductPriceTypes.includes(priceType.id)
                                                    ? _ctx.$t('product.active')
                                                    : _ctx.$t('product.notActive')), 3))
                    ], 2)
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_474, [
                  _createVNode("div", {
                    class: { 'data-to-row pt-3': _ctx.editMode }
                  }, [
                    _createVNode("span", _hoisted_475, _toDisplayString(_ctx.$t('employee.allowed-assign-employees')) + ":", 1),
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "checkbox",
                          class: "toggle",
                          "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => (_ctx.product.allowAssignEmployees = $event)),
                          onClick: _cache[123] || (_cache[123] = _withModifiers(($event: any) => (_ctx.disactivateOrActivateAllowAssignEmployees($event)), ["stop"]))
                        }, null, 512)), [
                          [_vModelCheckbox, _ctx.product.allowAssignEmployees]
                        ])
                      : (_openBlock(), _createBlock("p", {
                          key: 1,
                          class: [_ctx.product.allowAssignEmployees ? 'active' : 'not-active', "text-uppercase"]
                        }, _toDisplayString(_ctx.product.allowAssignEmployees ? _ctx.$t('product.active') : _ctx.$t('product.notActive')), 3))
                  ], 2)
                ]),
                _createVNode("div", _hoisted_476, [
                  _createVNode("span", _hoisted_477, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.external-provider-url')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_478, [
                        _withDirectives(_createVNode("input", {
                          "data-tab": _ctx.productDetailSections.General,
                          type: "text",
                          maxlength: "255",
                          class: "bookit-input product-input form-control h38",
                          "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => (_ctx.product.externalProviderUrl = $event))
                        }, null, 8, ["data-tab"]), [
                          [
                            _vModelText,
                            _ctx.product.externalProviderUrl,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("span", _hoisted_479, [
                          _hoisted_480,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ]),
                        _createVNode("span", _hoisted_481, [
                          _createVNode("span", {
                            class: { 'length-limit': (_ctx.product.externalProviderUrl?.length ?? 0) > 254 }
                          }, _toDisplayString(_ctx.product.externalProviderUrl?.length), 3),
                          _hoisted_482
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_483, _toDisplayString(_ctx.product.externalProviderUrl), 1))
                ]),
                _createVNode("div", _hoisted_484, [
                  _createVNode("span", _hoisted_485, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('product.promotion-banner-text')) + ":", 1)
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_486, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          id: "promotionBannerText",
                          class: "bookit-textarea product-textarea resize-off short-description form-control",
                          "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => (_ctx.product.promotionBannerText = $event)),
                          style: {"max-height":"80px","height":"80px"},
                          maxlength: "255",
                          "data-tab": _ctx.productDetailSections.General
                        }, null, 8, ["data-tab"]), [
                          [
                            _vModelText,
                            _ctx.product.promotionBannerText,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("span", _hoisted_487, [
                          _createVNode("span", {
                            class: { 'length-limit': (_ctx.product.promotionBannerText?.length ?? 0) > 1119 }
                          }, _toDisplayString(_ctx.product.promotionBannerText?.length ?? 0), 3),
                          _hoisted_488
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_489, _toDisplayString(_ctx.product.promotionBannerText), 1))
                ]),
                _createVNode("div", _hoisted_490, [
                  _createVNode("div", {
                    class: [{ 'pt-3': _ctx.editMode }, "pt-md-3 product-details-title"]
                  }, [
                    _createVNode("div", _hoisted_491, [
                      _withDirectives(_createVNode("div", _hoisted_492, [
                        _createVNode("div", _hoisted_493, _toDisplayString(_ctx.$t('help.aboutProductPolicyField')), 1)
                      ], 512), [
                        [_vShow, _ctx.showProductPolicyAbout]
                      ])
                    ]),
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('productPage.general.policyLabel')) + ": ", 1),
                      _createVNode("i", {
                        class: "icon-f icon-info fs-20",
                        style: {"margin-bottom":"3px"},
                        onMouseleave: _cache[126] || (_cache[126] = ($event: any) => (_ctx.showProductPolicyAbout = false)),
                        onMouseenter: _cache[127] || (_cache[127] = ($event: any) => (_ctx.showProductPolicyAbout = true))
                      }, null, 32)
                    ])
                  ], 2),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_494, [
                        _withDirectives(_createVNode("textarea", {
                          name: "textArea",
                          class: "bookit-textarea product-textarea resize-off long-description form-control",
                          "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => (_ctx.product.policy = $event)),
                          maxlength: "255"
                        }, null, 512), [
                          [_vModelText, _ctx.product.policy]
                        ]),
                        _createVNode("span", _hoisted_495, [
                          _createVNode("span", {
                            class: {
                                                    'length-limit': _ctx.product.policy?.length > 254
                                                }
                          }, _toDisplayString(_ctx.product.policy?.length || 0), 3),
                          _hoisted_496
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_497, _toDisplayString(_ctx.product.policy), 1))
                ]),
                (!_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_498))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_499, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_500, [
                        _createVNode("div", _hoisted_501, [
                          _createVNode(_component_RadioInput, {
                            name: "pricePerUnit",
                            value: true,
                            modelValue: _ctx.product.pricePerPerson,
                            "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => (_ctx.product.pricePerPerson = $event)),
                            class: "radio-select"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('product.pricePerPerson')), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("small", _hoisted_502, _toDisplayString(_ctx.$t('product.forExampleTicketForAFoodTour')), 1)
                        ]),
                        _createVNode("div", _hoisted_503, [
                          _createVNode(_component_RadioInput, {
                            name: "pricePerUnit",
                            value: false,
                            modelValue: _ctx.product.pricePerPerson,
                            "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => (_ctx.product.pricePerPerson = $event)),
                            class: "radio-select"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('product.pricePerUnit')), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("small", _hoisted_504, _toDisplayString(_ctx.$t('product.forExamplePriceForAJeep')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_505, [
                        _createVNode("div", _hoisted_506, [
                          _createVNode("span", _hoisted_507, _toDisplayString(_ctx.product.pricePerPerson ? _ctx.$t('product.pricePerPerson') : _ctx.$t('product.pricePerUnit')), 1),
                          _createVNode("small", _hoisted_508, _toDisplayString(_ctx.product.pricePerPerson
                                                    ? _ctx.$t('product.forExampleTicketForAFoodTour')
                                                    : _ctx.$t('product.forExamplePriceForAJeep')), 1)
                        ])
                      ]))
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_509, [
                      _createVNode("button", {
                        class: "delete-button",
                        onClick: _cache[131] || (_cache[131] = 
//@ts-ignore
(...args) => (_ctx.deleteProduct && _ctx.deleteProduct(...args))),
                        type: "button"
                      }, _toDisplayString(_ctx.$t('button.deleteProduct')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.General]
            ]),
            _withDirectives(_createVNode("div", _hoisted_510, [
              _createVNode("div", null, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_511, [
                      _createVNode("div", _hoisted_512, [
                        _createVNode("input", {
                          type: "file",
                          name: "",
                          id: "reponsible-person-image-upload-input",
                          style: {"display":"none"},
                          onChange: _cache[132] || (_cache[132] = ($event: any) => (_ctx.uploadingImageValidation($event, true))),
                          accept: "image/*"
                        }, null, 32),
                        (_ctx.product.responsiblePersonPhotoUrl)
                          ? (_openBlock(), _createBlock("div", _hoisted_513, [
                              _createVNode("img", {
                                width: "144",
                                height: "144",
                                src: _ctx.product.responsiblePersonPhotoUrl,
                                class: "about-me-round-image"
                              }, null, 8, ["src"]),
                              _createVNode("div", _hoisted_514, [
                                _createVNode("span", {
                                  class: "text-link",
                                  onClick: _cache[133] || (_cache[133] = ($event: any) => (_ctx.uploadFile($event, 'reponsible-person-image-upload-input')))
                                }, _toDisplayString(_ctx.$t('about-responsible-person.edit-photo')), 1),
                                _createVNode("span", {
                                  class: "text-link",
                                  onClick: _cache[134] || (_cache[134] = 
//@ts-ignore
(...args) => (_ctx.removeResponsiblePersonImage && _ctx.removeResponsiblePersonImage(...args)))
                                }, _toDisplayString(_ctx.$t('about-responsible-person.delete-photo')), 1)
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_515, [
                              _createVNode("button", {
                                onClick: _cache[135] || (_cache[135] = ($event: any) => (_ctx.uploadFile($event, 'reponsible-person-image-upload-input'))),
                                type: "button",
                                class: "btn-add-general"
                              }, [
                                _hoisted_516,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('about-responsible-person.upload-photo')), 1)
                              ])
                            ])),
                        _createVNode("div", _hoisted_517, [
                          _createVNode("div", _hoisted_518, [
                            (_ctx.responsiblePersonImgSrc)
                              ? (_openBlock(), _createBlock("div", _hoisted_519, [
                                  _createVNode(_component_cropper, {
                                    ref: "circleCropperLib",
                                    class: "cropper",
                                    src: _ctx.responsiblePersonImgSrc,
                                    "stencil-component": _ctx.circleStencil,
                                    "stencil-props": {
                                                            aspectRatio: 1,
                                                            lines: {
                                                                north: false,
                                                                west: false,
                                                                south: false,
                                                                east: false
                                                            },
                                                            previewClass: 'circle-preview'
                                                        }
                                  }, null, 8, ["src", "stencil-component"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.responsiblePersonImgSrc)
                              ? (_openBlock(), _createBlock("div", _hoisted_520, [
                                  _createVNode("div", _hoisted_521, [
                                    _createVNode("div", _hoisted_522, [
                                      _createVNode("div", _hoisted_523, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "btn save-image-btn browse-photo green-button mt-4",
                                          onClick: _cache[136] || (_cache[136] = 
//@ts-ignore
(...args) => (_ctx.saveResponsiblePersonImage && _ctx.saveResponsiblePersonImage(...args)))
                                        }, _toDisplayString(_ctx.$t('button.save')), 1)
                                      ]),
                                      _createVNode("div", _hoisted_524, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "clear-image-btn btn browse-photo gray-button mt-4",
                                          onClick: _cache[137] || (_cache[137] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                                        }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_525, [
                            _createVNode("div", _hoisted_526, [
                              _createVNode("span", _hoisted_527, _toDisplayString(_ctx.$t('about-responsible-person.full-name')) + ":", 1)
                            ]),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              maxlength: "30",
                              class: "bookit-input product-input form-control h48",
                              placeholder: _ctx.$t('about-responsible-person.placeholder.full-name'),
                              "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => (_ctx.product.responsiblePersonName = $event))
                            }, null, 8, ["placeholder"]), [
                              [
                                _vModelText,
                                _ctx.product.responsiblePersonName,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createVNode("span", _hoisted_528, [
                              (_ctx.product.responsiblePersonName)
                                ? (_openBlock(), _createBlock("span", {
                                    key: 0,
                                    class: { 'length-limit': _ctx.product.responsiblePersonName.length > 29 }
                                  }, _toDisplayString(_ctx.product.responsiblePersonName.length), 3))
                                : (_openBlock(), _createBlock("span", _hoisted_529, "0")),
                              _hoisted_530
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_531, [
                          _createVNode("div", _hoisted_532, [
                            _createVNode("span", _hoisted_533, _toDisplayString(_ctx.$t('about-responsible-person.description')) + ":", 1),
                            _createVNode("span", {
                              class: "pop-up-button",
                              onClick: _cache[139] || (_cache[139] = ($event: any) => (_ctx.routeToEdit('responsible-person-description')))
                            }, [
                              _hoisted_534
                            ])
                          ]),
                          _withDirectives(_createVNode("textarea", {
                            name: "textArea",
                            id: "fullDescription",
                            placeholder: _ctx.$t('about-responsible-person.placeholder.description'),
                            class: "bookit-textarea product-textarea resize-off long-description form-control",
                            "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => (_ctx.product.responsiblePersonDescription = $event)),
                            maxlength: "1200"
                          }, null, 8, ["placeholder"]), [
                            [
                              _vModelText,
                              _ctx.product.responsiblePersonDescription,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode("span", _hoisted_535, [
                            (_ctx.product.responsiblePersonDescription)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: { 'length-limit': _ctx.product.responsiblePersonDescription.length > 1199 }
                                }, _toDisplayString(_ctx.product.responsiblePersonDescription.length), 3))
                              : (_openBlock(), _createBlock("span", _hoisted_536, "0")),
                            _hoisted_537
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_538, [
                      _createVNode("div", _hoisted_539, [
                        _createVNode("img", {
                          src: _ctx.product.responsiblePersonPhotoUrl,
                          class: "about-me-round-image"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_540, [
                        _createVNode("span", _hoisted_541, _toDisplayString(_ctx.$t('about-responsible-person.full-name')) + ":", 1),
                        _createVNode("span", _hoisted_542, " " + _toDisplayString(_ctx.product.responsiblePersonName), 1)
                      ]),
                      _createVNode("div", _hoisted_543, [
                        _createVNode("div", _hoisted_544, _toDisplayString(_ctx.$t('about-responsible-person.description')) + ":", 1),
                        _createVNode("div", _hoisted_545, _toDisplayString(_ctx.product.responsiblePersonDescription), 1)
                      ])
                    ]))
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.ActivityOwner]
            ]),
            _withDirectives(_createVNode("div", _hoisted_546, [
              _createVNode("div", _hoisted_547, [
                _createVNode(_component_ProductSellingSettings, {
                  editMode: _ctx.editMode,
                  productId: _ctx.id,
                  useCashierProp: _ctx.product.useCashier,
                  useLocalsProp: _ctx.product.useLocals,
                  useGroupsProp: _ctx.product.useGroups,
                  useB2cChannelsProp: _ctx.product.useB2cChannels,
                  useDirectChannelsProp: _ctx.product.useDirectChannels,
                  useIndexProp: _ctx.product.useIndex,
                  printingTypeProp: _ctx.product.printingType,
                  onChangeSellingSetting: _ctx.changeSellingSetting,
                  onChangeSellingSettingPrintingType: _ctx.changeSellingSettingPrintingType
                }, null, 8, ["editMode", "productId", "useCashierProp", "useLocalsProp", "useGroupsProp", "useB2cChannelsProp", "useDirectChannelsProp", "useIndexProp", "printingTypeProp", "onChangeSellingSetting", "onChangeSellingSettingPrintingType"])
              ])
            ], 512), [
              [_vShow, _ctx.tab == _ctx.productDetailSections.SellingSettings]
            ])
          ])
        ], 2),
        _createVNode("div", _hoisted_548, [
          (_ctx.editMode)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'product', params: { id: _ctx.productId, tab: _ctx.tab } }
              }, {
                default: _withId(() => [
                  _createVNode("button", _hoisted_549, _toDisplayString(_ctx.$t('button.cancel')), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'catalog' }
              }, {
                default: _withId(() => [
                  _createVNode("button", _hoisted_550, _toDisplayString(_ctx.$t('button.catalog')), 1)
                ]),
                _: 1
              })),
          (_ctx.editMode)
            ? (_openBlock(), _createBlock("button", {
                key: 2,
                class: "button-submit",
                type: "submit",
                ref: "submitButtonRef",
                form: "product-save-form"
              }, _toDisplayString(_ctx.$t('button.save')), 513))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                to: { name: 'edit-product', params: { id: _ctx.id, tab: _ctx.tab } }
              }, {
                default: _withId(() => [
                  _createVNode("button", _hoisted_551, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('button.edit')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]))
        ])
      ], 34)
    ]),
    _createVNode(_component_OverlayModal, {
      isOpen: _ctx.externalCodeSearchModalIsOpen,
      "onUpdate:isOpen": _cache[147] || (_cache[147] = ($event: any) => (_ctx.externalCodeSearchModalIsOpen = $event))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_552, [
          _createVNode("button", {
            class: "btn-close",
            type: "button",
            onClick: _cache[142] || (_cache[142] = ($event: any) => (_ctx.externalCodeSearchModalClose()))
          }, [
            _hoisted_553
          ]),
          _createVNode("p", null, _toDisplayString(_ctx.$t('product.externalCodesTitle')), 1),
          _createVNode("div", _hoisted_554, [
            _createVNode("div", _hoisted_555, [
              _withDirectives(_createVNode("input", {
                required: "",
                type: "text",
                maxlength: "30",
                "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event: any) => (_ctx.externalCodeSearchModalSearchTerm = $event)),
                class: "bookit-input h48 external-codes-search-modal-input",
                onInput: _cache[144] || (_cache[144] = 
//@ts-ignore
(...args) => (_ctx.externalCodeSearchModalSearchTermChange && _ctx.externalCodeSearchModalSearchTermChange(...args)))
              }, null, 544), [
                [_vModelText, _ctx.externalCodeSearchModalSearchTerm]
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn-search",
                onClick: _cache[145] || (_cache[145] = 
//@ts-ignore
(...args) => (_ctx.externalCodesSearch && _ctx.externalCodesSearch(...args)))
              }, [
                _hoisted_556
              ])
            ]),
            _createVNode("div", _hoisted_557, [
              _createVNode("button", {
                class: "btn btn-link btn-delete-all",
                onClick: _cache[146] || (_cache[146] = 
//@ts-ignore
(...args) => (_ctx.externalCodesDeleteAll && _ctx.externalCodesDeleteAll(...args)))
              }, _toDisplayString(_ctx.$t('product.externalCodesDeleteAllButtonText')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_558, _toDisplayString(_ctx.$t('product.externalCodesLast100Title')), 1),
          _createVNode("div", null, [
            _createVNode("table", _hoisted_559, [
              _hoisted_560,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.externalCodeSearchResponse?.codes, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_561, _toDisplayString(item.code), 1),
                  _createVNode("td", {
                    class: {'status-color-red': item.status == 'Used', 'status-color-green': item.status == 'NotUsed'}
                  }, _toDisplayString(item.status), 3)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 512)), [
    [_vShow, _ctx.loaded]
  ])
})